<template>
  <div class="smart-classify-page">
    <site-header
      @institution-login="openSiteAuth('/login')"
      @login="openSiteAuth('/login')"
      @register="openSiteAuth('/register')"
    />
    <div v-if="false" class="smart-header">
      <img class="smart-logo" src="../assets/v2/img/logo-black.png" alt="logo" data-track-text="首页Logo" aria-label="首页Logo" @click="toPath('/index')" />
      <div class="smart-nav">
        <span data-track-text="首页" aria-label="首页" @click="toPath('/index')">首页</span>
        <span>
          <el-dropdown @command="gotoPage">
            <span>产品</span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="text">文本翻译</el-dropdown-item>
              <el-dropdown-item command="doc">文档翻译</el-dropdown-item>
              <el-dropdown-item command="ai">AI翻译</el-dropdown-item>
              <el-dropdown-item command="lange">多语种翻译</el-dropdown-item>
              <el-dropdown-item command="polish">润色改写</el-dropdown-item>
              <el-dropdown-item command="aiPPT">AI PPT</el-dropdown-item>
              <el-dropdown-item command="rag" class="nav-dropdown-new">
                <span>RAG知识库</span>
                <img :src="require('@/assets/new_icon.png')" alt="new" />
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </span>
        <span>
          <el-dropdown @command="handleServiceCommand">
            <span>服务</span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="toTransPro">人工翻译</el-dropdown-item>
              <el-dropdown-item command="standLangSet">术语词库</el-dropdown-item>
              <el-dropdown-item command="convertDoc">文档转换</el-dropdown-item>
              <el-dropdown-item command="mySelfDoc">我的文档</el-dropdown-item>
              <el-dropdown-item command="webTranslate" class="nav-dropdown-new">
                <span>网页翻译</span>
                <img :src="require('@/assets/new_icon.png')" alt="new" />
              </el-dropdown-item>
              <el-dropdown-item command="smartClassify" class="nav-dropdown-new">
                <span>数据分析</span>
                <img :src="require('@/assets/new_icon.png')" alt="new" />
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </span>
      </div>
      <div class="smart-user">
        <img class="smart-user-icon" src="../assets/v2/img/trans/help.png" alt="help" data-track-text="帮助" aria-label="帮助" @click="toPath('/help')" />
        <span class="smart-user-link" data-track-text="帮助" aria-label="帮助" @click="toPath('/help')">帮助</span>
        <template v-if="userInfo">
          <img class="smart-user-icon" src="../assets/v2/img/trans/login.png" alt="user" data-track-text="个人中心" aria-label="个人中心" @click="handleUserCommand('center')" />
          <el-dropdown @command="handleUserCommand">
            <span class="smart-user-link">{{ userInfo }}</span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="center">个人中心</el-dropdown-item>
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
        <span v-else class="smart-user-link">
          <span data-track-text="登录" aria-label="登录" @click="showIframe('/login')">登录</span>
          <span>/</span>
          <span data-track-text="注册" aria-label="注册" @click="showIframe('/register')">注册</span>
        </span>
      </div>
    </div>

    <nav ref="mobileWorkspaceNav" class="smart-mobile-view-switch" role="tablist" aria-label="智能分析视图">
	      <button
	        type="button"
	        role="tab"
	        data-track-id="smart-classify.mobile.settings"
	        data-track-text="目标设置"
	        :aria-selected="mobileWorkspacePane === 'settings' ? 'true' : 'false'"
        :class="{ active: mobileWorkspacePane === 'settings' }"
        @click="setMobileWorkspacePane('settings')"
      >目标设置</button>
	      <button
	        type="button"
	        role="tab"
	        data-track-id="smart-classify.mobile.analysis"
	        data-track-text="AI分析"
	        :aria-selected="mobileWorkspacePane === 'analysis' ? 'true' : 'false'"
        :class="{ active: mobileWorkspacePane === 'analysis' }"
        @click="setMobileWorkspacePane('analysis')"
      >AI分析</button>
    </nav>

    <div class="smart-workspace-shell">
      <nav class="site-tool-sidebar" aria-label="全部功能">
        <section
          v-for="section in siteToolSections"
          :key="section.key"
          class="site-tool-section"
        >
          <h2 class="site-tool-section-title">{{ section.title }}</h2>
          <div class="site-tool-list">
            <button
              v-for="item in section.items"
              :key="item.text"
              type="button"
              class="site-tool-item"
              :class="{ active: item.url === '/smart-classify' }"
              :data-track-text="item.text"
              :aria-label="item.text"
              :aria-current="item.url === '/smart-classify' ? 'page' : null"
              @click="navigateToSiteTool(item)"
            >
              <i class="site-tool-icon" :class="item.icon" aria-hidden="true"></i>
              <span class="site-tool-name">{{ item.text }}</span>
            </button>
          </div>
        </section>
      </nav>

      <div
        class="smart-layout"
        :class="`mobile-pane-${mobileWorkspacePane}`"
        @focusin.capture="handleWorkspaceFocus"
      >
      <!-- 左侧表单 -->
      <aside class="smart-panel side-panel">
        <div class="target-head">
          <div>
            <div class="panel-title">目标网址管理</div>
            <div class="target-subtitle">最多10个目标，每个网址最多5个锚点词</div>
          </div>
          <el-button class="add-target-btn" data-track-text="添加网址" aria-label="添加网址" type="primary" size="mini" icon="el-icon-plus" @click="trackAddTarget">添加网址</el-button>
        </div>

        <div class="target-list">
          <div
            v-for="(target, index) in targets"
            :key="target.id"
            class="target-card"
            data-track-text="选择目标网址"
            aria-label="选择目标网址"
            :class="{ active: activeTargetId === target.id }"
            @click="selectTarget(target)"
          >
            <div class="target-card-head">
              <span class="target-index">{{ index + 1 }}</span>
              <span class="target-card-title">目标网址</span>
              <div class="target-card-actions">
                <el-tooltip content="删除目标" placement="top">
                  <el-button data-track-text="删除目标网址" aria-label="删除目标网址" type="text" icon="el-icon-delete" @click.stop="removeTarget(target.id)" />
                </el-tooltip>
              </div>
            </div>
            <el-input v-model="target.url" size="small" placeholder="https://example.com" clearable @focus="selectTarget(target)" />
            <div class="target-keyword-head">
              <span>锚点词</span>
              <span>({{ target.keywords.length }}/5)</span>
            </div>
            <div class="target-keyword-input">
              <el-input
                v-model="target.keywordInput"
                size="mini"
                placeholder="输入锚点词"
                @keyup.enter.native="addTargetKeyword(target)"
                @focus="selectTarget(target)"
              />
              <el-button data-track-text="添加锚点词" aria-label="添加锚点词" size="mini" type="text" @click.stop="addTargetKeyword(target)">添加</el-button>
            </div>
            <div v-if="target.keywords.length" class="target-tags">
              <el-tag
                v-for="keyword in target.keywords"
                :key="keyword"
                size="mini"
                closable
                @close="removeTargetKeyword(target, keyword)"
              >{{ keyword }}</el-tag>
            </div>
            <div v-else class="target-empty">暂无锚点词，点击“添加”设置</div>
          </div>
        </div>

        <el-form class="batch-form" label-position="top" :model="form">
          <div class="schedule-box">
            <div class="schedule-title">抓取时间设定</div>
            <div class="schedule-segment">
              <button type="button" data-track-text="手动执行" aria-label="手动执行" :class="{ active: form.scheduleMode === 'manual' }" @click="form.scheduleMode = 'manual'">手动执行</button>
              <button type="button" data-track-text="间隔执行" aria-label="间隔执行" :class="{ active: form.scheduleMode === 'interval' }" @click="form.scheduleMode = 'interval'">间隔执行</button>
              <button type="button" data-track-text="定时执行" aria-label="定时执行" :class="{ active: form.scheduleMode === 'timed' }" @click="form.scheduleMode = 'timed'">定时执行</button>
            </div>
            <el-form-item v-if="form.scheduleMode === 'interval'" label="执行间隔（分钟）">
              <el-input v-model.number="form.intervalMinutes" type="number" min="1" max="1440" />
            </el-form-item>
            <el-form-item v-if="form.scheduleMode === 'timed'" label="执行时间">
              <el-input v-model="form.scheduleTime" type="time" />
            </el-form-item>
          </div>
          <el-form-item class="compliance-item">
            <el-checkbox v-model="form.autoImportRag">
              抓取完成后自动导入RAG，并导入下载到的文件
            </el-checkbox>
          </el-form-item>
          <el-form-item class="compliance-item">
            <el-checkbox v-model="form.complianceConfirmed">
              我确认对目标站点内容具有合法处理权，并同意不抓取受限内容
            </el-checkbox>
          </el-form-item>
          <el-button class="submit-btn" data-track-text="开始抓取" aria-label="开始抓取" type="primary" :loading="submitting" @click="submitBatch">开始抓取</el-button>
          <div class="compliance-help">*数据处理提示：抓取内容将发送到系统默认大模型进行关键词分类，不用于本功能外用途</div>
        </el-form>

        <div class="history-head">
          <span>历史任务</span>
          <el-button data-track-text="刷新历史任务" aria-label="刷新历史任务" type="text" @click="loadTasks">刷新</el-button>
        </div>
        <div class="history-list">
          <div
            v-for="(task, index) in tasks"
            :key="task.taskId"
            class="history-item"
            data-track-text="打开历史任务"
            aria-label="打开历史任务"
            :class="{ active: currentTask && currentTask.taskId === task.taskId }"
            @click="openTask(task)"
          >
            <div class="history-card-head">
              <span class="target-index">{{ index + 1 }}</span>
              <div class="history-url" :title="decodeUrl(task.startUrl)">{{ decodeUrl(task.startUrl) }}</div>
            </div>
            <div v-if="historyKeywords(task).length" class="history-keywords" :title="historyKeywordTitle(task)">
              <span class="history-keyword-label">锚点词</span>
              <el-tag v-for="keyword in historyKeywords(task)" :key="keyword" size="mini">{{ keyword }}</el-tag>
            </div>
            <div class="target-progress">
              <span>抓取进度</span>
              <el-progress :percentage="task.progress || 0" :show-text="false" />
              <em>{{ task.progress || 0 }}%</em>
            </div>
          </div>
          <el-empty v-if="!tasks.length" description="暂无历史任务" :image-size="80" />
        </div>
      </aside>

      <!-- 右侧主内容 -->
      <main class="smart-main">
        <section class="smart-panel workbench-panel">
          <div class="workbench-head">
            <div>
              <div class="panel-title">AI智能分析平台</div>
              <div class="workbench-subtitle">最多10个目标 · AI内容提取 · 自动生成RAG报告</div>
            </div>
          </div>

          <el-tabs v-model="activeWorkspaceTab" class="workspace-tabs">
            <el-tab-pane label="抓取进程" name="process">
              <div v-if="hasTaskContext" class="process-grid">
                <div class="process-card">
                  <div class="result-head">
            <div>
              <div class="process-card-title">当前目标</div>
              <div class="task-url" v-if="selectedTarget">{{ decodeUrl(selectedTarget.url || (currentTask && currentTask.startUrl)) || '请在左侧填写目标网址' }}</div>
            </div>
            <div v-if="currentTask" class="task-actions">
              <el-tag :type="statusType(currentTask.status)">{{ statusText(currentTask.status) }}</el-tag>
              <el-tooltip v-if="canRetryTask(currentTask)" content="重试分析数据" placement="top">
                <el-button class="retry-task-btn" data-track-text="重试分析数据" aria-label="重试分析数据" type="text" icon="el-icon-refresh" :loading="submitting" @click="retryTask" />
              </el-tooltip>
              <el-tooltip v-if="canCancelTask(currentTask)" content="取消当前抓取" placement="top">
                <el-button
                  class="cancel-task-btn"
                  data-track-text="取消当前抓取"
                  aria-label="取消当前抓取"
                  type="text"
                  icon="el-icon-close"
                  :loading="cancellingTaskId === currentTask.taskId"
                  @click="cancelTask"
                />
              </el-tooltip>
            </div>
          </div>
          <el-progress :percentage="selectedTarget ? selectedTarget.progress || 0 : 0" />
          <div v-if="currentTask && currentTask.progressMessage" class="task-live-progress">
            <div>
              <span>{{ progressStageText(currentTask.progressStage) }}</span>
              <strong>{{ publicDisplayText(currentTask.progressMessage) }}</strong>
            </div>
            <button
              v-if="currentTask.currentPageUrl"
              type="button"
              class="safe-url-link current-page-link"
              data-track-text="打开当前处理页面"
              aria-label="打开当前处理页面"
              @click="openExternalUrl(currentTask.currentPageUrl)"
            >当前页面</button>
          </div>
          <div class="stat-grid" v-if="currentTask">
            <div><span>{{ currentTask.successPages || 0 }}</span><label>成功页数</label></div>
          </div>
          <el-alert v-if="currentTask && currentTask.errorMessage" type="error" :closable="false" :title="publicDisplayText(currentTask.errorMessage)" class="task-error" />
                </div>

                <div class="process-card">
                  <div class="process-card-title">目标状态</div>
                  <div class="target-progress-list">
                    <button
                      v-for="(target, index) in targets"
                      :key="target.id"
                      type="button"
                      class="target-pill"
                      data-track-text="切换目标状态"
                      aria-label="切换目标状态"
                      :class="{ active: activeTargetId === target.id }"
                      @click="selectTarget(target)"
                    >
                      <span>{{ index + 1 }}</span>
                      <em>{{ targetStatusText(target) }}</em>
                      <strong>{{ target.progress || 0 }}%</strong>
                    </button>
                  </div>
                </div>
              </div>

              <div class="process-log">
                <div class="process-log-head">
                  <span>抓取日志</span>
                  <el-button data-track-text="清空抓取日志显示" aria-label="清空抓取日志显示" type="text" @click="clearLogs">清空显示</el-button>
                </div>
                <div v-if="batchLogs.length" class="process-log-list">
                  <div v-for="log in batchLogs" :key="log.id" class="process-log-item" :class="log.type">
                    <span>{{ log.time }}</span>
                    <p>{{ log.message }}</p>
                  </div>
                </div>
                <el-empty v-else description="暂无抓取日志" :image-size="80" />
              </div>
            </el-tab-pane>

            <el-tab-pane label="匹配结果" name="results">
        <div class="result-panel">
          <div class="result-head">
            <div class="result-title-row">
              <div class="panel-title">分析结果</div>
              <button v-if="currentTask && currentTask.startUrl" type="button" class="safe-url-link result-url-link" data-track-text="打开网页地址" aria-label="打开网页地址" @click="openExternalUrl(currentTask.startUrl)">
                网页地址
              </button>
            </div>
            <div class="result-actions">
              <el-button :disabled="!currentTask" data-track-text="刷新分析结果" aria-label="刷新分析结果" size="mini" @click="loadPages()">刷新结果</el-button>
              <el-button
                v-if="showManualRagImportButton(currentTask)"
                size="mini"
                type="primary"
                icon="el-icon-upload"
                :loading="exporting"
                data-track-text="生成并写入RAG"
                aria-label="生成并写入RAG"
                @click="exportToRag"
              >生成并写入RAG</el-button>
            </div>
          </div>

          <!-- 任务运行中：进度提示和已落库页面同步展示 -->
          <div
            v-if="currentTask && ['PENDING', 'RUNNING'].includes(currentTask.status)"
            class="running-placeholder"
            :class="{ 'has-pages': pages.length }"
          >
            <i class="el-icon-loading running-icon"></i>
            <span>
              {{ publicDisplayText(currentTask.progressMessage) || '任务处理中，正在等待页面分析结果…' }}
              <em v-if="pages.length">已落库 {{ pages.length }} 页，结果会继续自动更新</em>
            </span>
          </div>

          <div v-if="currentTask && currentTask.status === 'SUCCESS'" class="success-summary">
            已成功抓取并分析 {{ currentTask.successPages || 0 }} 页，其中精确命中 {{ exactMatchedPages.length }} 页
          </div>
          <div v-if="currentTask && currentTask.status === 'SUCCESS' && currentTask.reportRagId" class="rag-result">
            <div><span>RAG知识库</span><strong :title="taskRagName(currentTask)">{{ taskRagName(currentTask) }}</strong></div>
            <div><span>报告文档</span><strong :title="currentTask.reportDocumentName">{{ currentTask.reportDocumentName || '已写入' }}</strong></div>
          </div>
          <div v-else-if="currentTask && currentTask.status === 'SUCCESS' && currentTask.reportStatus === 'IMPORTING'" class="rag-result">
            <div><span>RAG知识库</span><strong>自动导入中</strong></div>
          </div>
          <div v-if="showPageResults" class="matched-pages-summary">
            <div class="matched-pages-head">
              <strong>{{ ['PENDING', 'RUNNING'].includes(currentTask.status) ? '已分析的精确命中页面（持续更新）' : '精确命中的具体页面' }}</strong>
              <span>精确命中 {{ exactMatchedPages.length }} 页 · 已分析 {{ pages.length }} 页</span>
            </div>
            <div v-if="matchedPages.length" class="matched-pages-list">
              <div v-for="page in matchedPages" :key="`matched-${page.id || page.url}`" class="matched-page-item">
                <div class="matched-page-main">
                  <el-tag size="mini" type="success">精确命中</el-tag>
                  <button type="button" class="safe-url-link title-link" data-track-text="打开命中页面" aria-label="打开命中页面" @click="openExternalUrl(page.url)">
                    {{ page.title || page.originalTitle || decodeUrl(page.url) || '未命名页面' }}
                  </button>
                </div>
                <div class="matched-page-meta">
                  <span>精确命中：{{ pageExactMatchedKeywords(page).join('、') }}</span>
                  <span :title="decodeUrl(page.url)">{{ decodeUrl(page.url) }}</span>
                </div>
              </div>
            </div>
            <div v-else class="matched-pages-empty">
              {{ ['PENDING', 'RUNNING'].includes(currentTask.status) ? '当前已落库页面暂未精确命中，任务仍在继续。' : '本次抓取的页面均未精确命中任务关键词。' }}
            </div>
          </div>
          <el-tabs
            v-if="showPageResults"
            v-model="activeResultTab"
            class="result-tabs"
            type="card"
          >
            <el-tab-pane label="精确命中页面" name="all">
              <el-table :data="matchedPages" stripe size="mini" class="result-table">
                <el-table-column prop="title" label="页面标题" min-width="260" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <button type="button" class="safe-url-link title-link" data-track-text="打开分析页面标题" aria-label="打开分析页面标题" @click="openExternalUrl(scope.row.url)">
                      {{ scope.row.title || '—' }}
                    </button>
                  </template>
                </el-table-column>
                <el-table-column label="匹配类型" width="178">
                  <template slot-scope="scope">
                    <div class="page-match-tags">
                      <el-tag size="mini" type="success">精确命中</el-tag>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="匹配关键词" min-width="210">
                  <template slot-scope="scope">
                    <div class="page-keyword-lines">
                      <span><em class="exact">精确</em>{{ pageExactMatchedKeywords(scope.row).join('、') }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="publishDate" label="发布时间" width="150" />
                <el-table-column label="文件" width="90">
                  <template slot-scope="scope">{{ pageFileCount(scope.row) || '—' }}</template>
                </el-table-column>
                <el-table-column prop="contentSummary" label="摘要" min-width="360" show-overflow-tooltip />
                <el-table-column label="链接" width="100">
                  <template slot-scope="scope">
                    <button type="button" class="safe-url-link" data-track-text="打开分析页面链接" aria-label="打开分析页面链接" @click="openExternalUrl(scope.row.url)">打开</button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane
              v-for="(page, index) in matchedPages"
              :key="pageTabName(page, index)"
              :name="pageTabName(page, index)"
            >
              <span slot="label" class="tab-label" :title="pageTabTitle(page, index)">
                <span class="page-match-mark" :class="pageMatchMarkClass(page)">{{ pageMatchMarkText(page) }}</span>
                <span class="tab-label-text">{{ pageTabTitle(page, index) }}</span>
                <button
                  type="button"
                  class="tab-download-btn"
                  :disabled="downloadPageIndex === index"
	                  title="下载Word文档"
	                  data-track-text="下载分析页Word文档"
	                  aria-label="下载分析页Word文档"
	                  @mousedown.stop.prevent
                  @mouseup.stop.prevent
                  @click.stop.prevent="downloadPageWord(page, index)"
                >
                  <i :class="downloadPageIndex === index ? 'el-icon-loading' : 'el-icon-download'"></i>
                </button>
              </span>
              <div class="page-report">
                <div class="page-report-title-row">
                  <h2 class="page-report-title">{{ pageReportTitle(page) }}</h2>
                  <el-button
                    class="page-report-download-btn"
                    type="primary"
                    size="mini"
                    icon="el-icon-download"
                    :loading="downloadPageIndex === index"
                    data-track-text="下载word"
                    aria-label="下载word"
                    @click="downloadPageWord(page, index)"
                  >下载word</el-button>
                </div>

                <section class="report-section">
                  <h3>一、概况</h3>
                  <div class="report-overview">
                    <div><span>抓取来源：</span>{{ siteName(currentTask.startUrl) }}（{{ decodeUrl(currentTask.startUrl) }}）</div>
                    <div><span>页面匹配：</span>{{ pageMatchDescription(page) }}</div>
                    <div><span>精确命中关键词：</span>{{ pageExactMatchedKeywords(page).join('、') || '—' }}</div>
                    <div><span>匹配条数：</span>{{ pageMatchedCount(page) }} 条{{ pageDateText(page) }}</div>
                    <div><span>时间跨度：</span>{{ pageDateRange(page) }}</div>
                  </div>
                </section>

                <section class="report-section">
                  <h3>二、抓取内容列表</h3>
                  <el-table :data="[page]" stripe size="mini" class="report-table">
                    <el-table-column prop="title" label="中文标题" min-width="260" show-overflow-tooltip>
                      <template slot-scope="scope">
	                        <button type="button" class="safe-url-link title-link" data-track-text="打开报告页面标题" aria-label="打开报告页面标题" @click="openExternalUrl(scope.row.url)">
                          {{ scope.row.title || '—' }}
                        </button>
                      </template>
                    </el-table-column>
                    <el-table-column prop="originalTitle" label="原标题（一般是英文）" min-width="240" show-overflow-tooltip>
                      <template slot-scope="scope">{{ scope.row.originalTitle || '—' }}</template>
                    </el-table-column>
                    <el-table-column prop="publishDate" label="发布时间" width="130">
                      <template slot-scope="scope">{{ scope.row.publishDate || '—' }}</template>
                    </el-table-column>
                    <el-table-column label="链接" width="90">
                      <template slot-scope="scope">
	                        <button type="button" class="safe-url-link" data-track-text="打开报告页面链接" aria-label="打开报告页面链接" @click="openExternalUrl(scope.row.url)">打开</button>
                      </template>
                    </el-table-column>
                  </el-table>
                </section>

                <section class="report-section">
                  <h3>三、相关文件</h3>
                  <div v-if="pageFiles(page).length" class="file-list">
                    <div v-for="file in pageFiles(page)" :key="file.id || file.sourceUrl" class="file-item">
                      <div class="file-main">
                        <i class="el-icon-document"></i>
                        <button
                          type="button"
	                          class="safe-url-link file-name"
	                          :title="file.fileName || file.sourceUrl"
	                          data-track-text="打开关联文件"
	                          aria-label="打开关联文件"
	                          @click="openFileLink(file)"
                        >{{ file.fileName || '未命名文件' }}</button>
                        <el-tag size="mini" :type="file.status === 'SUCCESS' ? 'success' : 'danger'">{{ fileStatusText(file.status) }}</el-tag>
                      </div>
                      <div class="file-meta">
                        <span>{{ file.fileExtension || '文件' }}</span>
                        <span>{{ fileSizeText(file.fileSize) }}</span>
                        <span v-if="file.errorMessage" :title="publicDisplayText(file.errorMessage)">{{ publicDisplayText(file.errorMessage) }}</span>
                      </div>
                    </div>
                  </div>
                  <div v-else class="empty-report-block">暂无文件链接</div>
                </section>

                <section class="report-section">
                  <h3>四、对链接内容的汇总</h3>
                  <div v-if="pageThemeGroups(page).length" class="summary-groups">
                    <div v-for="(group, groupIndex) in pageThemeGroups(page)" :key="group.theme" class="summary-group">
                      <h4>{{ groupIndex + 1 }}、{{ group.theme }}</h4>
                      <div v-for="(item, itemIndex) in group.items" :key="`${group.theme}-${itemIndex}`" class="summary-item">
                        <p class="summary-item-title">{{ item.keyword }}：{{ item.summary || page.contentSummary || '暂无摘要' }}</p>
                        <ul v-if="item.evidences && item.evidences.length" class="evidence-list">
                          <li v-for="(evidence, evidenceIndex) in item.evidences" :key="evidenceIndex">{{ evidence }}</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div v-else class="empty-report-block">暂无可汇总内容</div>
                </section>

                <div class="page-detail-url">
                  <i class="el-icon-link"></i>
	                  <button type="button" class="safe-url-link" data-track-text="打开页面详情网址" aria-label="打开页面详情网址" @click="openExternalUrl(page.url)">
                    {{ decodeUrl(page.url) || '网页地址' }}
                  </button>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>

          <el-empty
            v-else-if="currentTask && !['PENDING', 'RUNNING'].includes(currentTask.status)"
            :description="emptyResultText(currentTask)"
            :image-size="80"
          />
          <el-empty v-else-if="!currentTask" description="请选择或创建一个任务" :image-size="100" />
        </div>
            </el-tab-pane>

            <el-tab-pane label="数据中心" name="data">
              <div class="data-center-head">
                <div>
                  <div class="process-card-title">抓取记录</div>
                  <div class="data-center-subtitle">
                    <span v-if="currentTask">{{ decodeUrl(currentTask.startUrl) }}</span>
                    <span v-else>请选择或创建一个任务</span>
                  </div>
                </div>
	                <el-button :disabled="!currentTask" size="mini" data-track-text="刷新抓取记录" aria-label="刷新抓取记录" @click="loadPages()">刷新记录</el-button>
              </div>
              <div v-if="currentTask" class="data-current-summary">
                <div><span>任务状态</span><strong>{{ taskRunStateText(currentTask.status) }}</strong></div>
                <div><span>成功页数</span><strong>{{ currentTask.successPages || 0 }}</strong></div>
                <div><span>精确命中页数</span><strong>{{ exactMatchedPages.length }}</strong></div>
                <div><span>RAG知识库</span><strong :title="taskRagName(currentTask)">{{ taskRagName(currentTask) || '—' }}</strong></div>
              </div>
              <el-table v-if="currentTask && matchedPages.length" :data="matchedPages" stripe size="mini" class="data-table">
                <el-table-column label="页面标题" min-width="220" show-overflow-tooltip>
                  <template slot-scope="scope">
	                    <button type="button" class="safe-url-link title-link" data-track-text="打开数据中心页面标题" aria-label="打开数据中心页面标题" @click="openExternalUrl(scope.row.url)">
                      {{ scope.row.title || scope.row.originalTitle || '—' }}
                    </button>
                  </template>
                </el-table-column>
                <el-table-column label="来源网址" min-width="260" show-overflow-tooltip>
                  <template slot-scope="scope">
	                    <button type="button" class="safe-url-link title-link" data-track-text="打开数据中心来源网址" aria-label="打开数据中心来源网址" @click="openExternalUrl(scope.row.url)">
                      {{ decodeUrl(scope.row.url) || '网页地址' }}
                    </button>
                  </template>
                </el-table-column>
                <el-table-column label="匹配类型" width="178">
                  <template slot-scope="scope">
                    <div class="page-match-tags">
                      <el-tag size="mini" type="success">精确命中</el-tag>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="匹配关键词" min-width="210">
                  <template slot-scope="scope">
                    <div class="page-keyword-lines">
                      <span><em class="exact">精确</em>{{ pageExactMatchedKeywords(scope.row).join('、') }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="publishDate" label="发布时间" width="120">
                  <template slot-scope="scope">{{ scope.row.publishDate || '—' }}</template>
                </el-table-column>
                <el-table-column label="文件" width="90">
                  <template slot-scope="scope">{{ pageFileCount(scope.row) || '—' }}</template>
                </el-table-column>
                <el-table-column label="状态" width="110">
                  <template slot-scope="scope">
                    <el-tag size="mini" :type="statusType(scope.row.status)">{{ statusText(scope.row.status) }}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="contentSummary" label="摘要" min-width="260" show-overflow-tooltip />
                <el-table-column label="操作" width="100">
                  <template slot-scope="scope">
	                    <el-button type="text" size="mini" data-track-text="打开数据中心记录" aria-label="打开数据中心记录" @click="openExternalUrl(scope.row.url)">打开</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-empty v-else-if="currentTask" description="当前任务暂无精确命中记录" :image-size="90" />
              <el-empty v-else description="请选择或创建一个任务" :image-size="90" />
            </el-tab-pane>
          </el-tabs>
        </section>
      </main>
      </div>
    </div>

    <div v-if="false" class="text-wrapper_9 smart-footer flex-col">
      <span class="paragraph_9">
        ©&nbsp;2020&nbsp;北京容智科技发展有限公司&nbsp;
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="noopener noreferrer">京ICP备19036872号-3</a>
        &nbsp;All&nbsp;rights&nbsp;reserved.&nbsp;京公网安备&nbsp;
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11011402010815" target="_blank" rel="noopener noreferrer">11011402010815</a><br />
        联系邮箱：<a href="mailto:info@wiseivy.com.cn?subject=微思翻译咨询">info&#64;wiseivy.com.cn</a>&nbsp;联系电话：010-80755328
      </span>
    </div>
    <site-footer class="smart-site-footer" />
  </div>
</template>

<script>
import { Base64 } from 'js-base64'
import { saveAs } from 'file-saver'
import {
  Document,
  HeadingLevel,
  Packer,
  Paragraph,
  Table,
  TableCell,
  TableRow,
  TextRun,
  WidthType,
} from 'docx'
import { authServiceClient, outRequest, userStatusRequest } from '../tools/api/auth-api'
import {
  ragServiceClient,
  RagBootstrapRequest,
  RagKnowledgeBaseCreateRequest,
  RagKnowledgeBaseUploadRequest
} from '../tools/api/rag-api'
import { trackElementClick } from '../utils/track'
import SiteHeader from '@/components/home/SiteHeader.vue'
import SiteFooter from '@/components/home/SiteFooter.vue'
import createWorkspaceMenu from '@/config/workspaceMenu'

const workspaceMenu = createWorkspaceMenu()
const SITE_TOOL_SECTIONS = Object.keys(workspaceMenu).map(key => ({
  key,
  title: workspaceMenu[key].title,
  items: workspaceMenu[key].list
}))

const TASK_CONTEXT_STORAGE_KEY = 'smart-classify-task-context-v1'
const CRAWL_MAX_DEPTH = 1
const CRAWL_MAX_PAGES = 1

export default {
  name: 'SmartClassify',
  components: { SiteHeader, SiteFooter },
  data() {
    const initialTargetId = Date.now()
    return {
      form: {
        scheduleMode: 'manual',
        intervalMinutes: 30,
        scheduleTime: '09:00',
        autoImportRag: true,
        complianceConfirmed: false,
        policyVersion: 'smart-classify-policy-v1',
      },
      targets: [{
        id: initialTargetId,
        url: '',
        keywords: [],
        keywordInput: '',
        taskId: '',
        task: null,
        pages: [],
        progress: 0,
        status: 'IDLE',
        lastStatus: 'IDLE',
        lastProgressMessage: '',
        logs: [],
        logCursor: '',
        logsLoaded: false,
        logDisplayVersion: 0,
      }],
      nextTargetId: initialTargetId + 1,
      activeTargetId: initialTargetId,
      mobileWorkspacePane: 'settings',
      activeWorkspaceTab: 'process',
      submitting: false,
      exporting: false,
      cancellingTaskId: '',
      tasks: [],
      currentTask: null,
      pages: [],
      pageTotal: 0,
      pageQuery: { current: 1, size: 200 },
      activeResultTab: 'all',
      downloadPageIndex: null,
      pollTimer: null,
      taskLoadPromises: {},
      taskRequestVersions: {},
      pageLoadPromises: {},
      pageRequestVersions: {},
      logLoadPromises: {},
      loginLayerIndex: null,
      loginCheckTimer: null,
      loginAuthSnapshot: '',
      userInfo: '',
      currentScopeId: '',
      autoExportTaskIds: {},
      recentTaskIds: [],
      activeTaskContextId: '',
      siteToolSections: SITE_TOOL_SECTIONS,
    }
  },
  computed: {
    selectedTarget() {
      return this.targets.find(target => target.id === this.activeTargetId) || this.targets[0] || null
    },
    batchLogs() {
      return (this.selectedTarget && this.selectedTarget.logs) || []
    },
    hasTaskContext() {
      return !!(this.currentTask || this.targets.some(target => target.taskId))
    },
    runningTargets() {
      return this.targets.filter(target => target.taskId && ['PENDING', 'RUNNING'].includes(target.status))
    },
    matchedPages() {
      return this.exactMatchedPages
    },
    exactMatchedPages() {
      return this.pages.filter(page => this.pageExactMatchedKeywords(page).length > 0)
    },
    showPageResults() {
      return !!(this.currentTask && this.pages.length)
    },
  },
  watch: {
    activeWorkspaceTab(value) {
      if (value === 'data' && this.currentTask) {
        this.loadPages()
      }
    },
  },
  mounted() {
    this.bootstrapPage()
    window.addEventListener('storage', this.handleStorageChange)
    window.addEventListener('message', this.handleLoginMessage)
  },
  beforeDestroy() {
    this.stopPolling()
    this.stopLoginCheckTimer()
    window.removeEventListener('storage', this.handleStorageChange)
    window.removeEventListener('message', this.handleLoginMessage)
  },
  methods: {
    navigateToSiteTool(item) {
      if (!item || item.url === '/smart-classify') return
      if (item.url === '/trans-pro') {
        window.open('/trans-pro/index', '_self')
        return
      }
      if (item.type) {
        this.$router.push({
          path: item.url,
          query: { type: item.type }
        })
        return
      }
      this.$router.push(item.url)
    },
    parseKeywordList(value) {
      let source = Array.isArray(value) ? value : [value]
      if (typeof value === 'string') {
        const text = value.trim()
        if (text.startsWith('[')) {
          try {
            const parsed = JSON.parse(text)
            if (Array.isArray(parsed)) source = parsed
          } catch (e) {}
        }
      }
      const keywords = source.flatMap(item => String(item || '').split(/[\n,，、]/)).map(item => item.trim()).filter(Boolean)
      return Array.from(new Set(keywords))
    },
    decodeUrl(url) {
      if (!url) return ''
      const text = String(url)
      try {
        const parsed = new URL(text)
        const params = []
        parsed.searchParams.forEach((value, key) => { params.push(`${key}=${value}`) })
        return `${parsed.origin}${parsed.pathname}${params.length ? `?${params.join('&')}` : ''}${parsed.hash ? decodeURIComponent(parsed.hash) : ''}`
      } catch (e) {
        try { return decodeURIComponent(text) } catch (err) {
          try { return decodeURI(text) } catch (ignore) { return text }
        }
      }
    },
    toPath(path) { this.$router.push(path) },
    getMetadata() {
      return { token: localStorage.getItem('token') }
    },
    readTaskContext() {
      try {
        const stored = JSON.parse(sessionStorage.getItem(TASK_CONTEXT_STORAGE_KEY) || '{}')
        const taskIds = Array.from(new Set((Array.isArray(stored.taskIds) ? stored.taskIds : [])
          .map(taskId => String(taskId || '').trim())
          .filter(Boolean)))
          .slice(0, 10)
        const activeTaskId = String(stored.activeTaskId || '').trim()
        return { taskIds, activeTaskId: taskIds.includes(activeTaskId) ? activeTaskId : '' }
      } catch (e) {
        return { taskIds: [], activeTaskId: '' }
      }
    },
    persistTaskContext() {
      const boundTaskIds = this.targets.map(target => target.taskId).filter(Boolean)
      const taskIds = Array.from(new Set([
        this.activeTaskContextId,
        ...boundTaskIds,
        ...this.recentTaskIds,
      ].filter(Boolean).map(taskId => String(taskId))))
        .filter(Boolean)
        .slice(0, 10)
      this.recentTaskIds = taskIds
      if (!taskIds.includes(this.activeTaskContextId)) this.activeTaskContextId = taskIds[0] || ''
      if (!taskIds.length) {
        try { sessionStorage.removeItem(TASK_CONTEXT_STORAGE_KEY) } catch (e) {}
        return
      }
      try {
        sessionStorage.setItem(TASK_CONTEXT_STORAGE_KEY, JSON.stringify({
          taskIds,
          activeTaskId: this.activeTaskContextId,
        }))
      } catch (e) {}
    },
    rememberTaskContext(taskId, options = {}) {
      const normalizedTaskId = String(taskId || '').trim()
      if (!normalizedTaskId) return
      this.recentTaskIds = [normalizedTaskId, ...this.recentTaskIds.filter(item => item !== normalizedTaskId)].slice(0, 10)
      if (options.active !== false) this.activeTaskContextId = normalizedTaskId
      this.persistTaskContext()
    },
    forgetTaskContext(taskId) {
      const normalizedTaskId = String(taskId || '').trim()
      if (!normalizedTaskId) return
      this.recentTaskIds = this.recentTaskIds.filter(item => item !== normalizedTaskId)
      if (this.activeTaskContextId === normalizedTaskId) {
        this.activeTaskContextId = (this.selectedTarget && this.selectedTarget.taskId) || this.recentTaskIds[0] || ''
      }
      this.persistTaskContext()
    },
    clearTaskContext() {
      try { sessionStorage.removeItem(TASK_CONTEXT_STORAGE_KEY) } catch (e) {}
      this.recentTaskIds = []
      this.activeTaskContextId = ''
    },
    resolveTaskForBootstrap(taskId, tasks = []) {
      const listedTask = tasks.find(task => String(task.taskId) === String(taskId))
      if (listedTask) return Promise.resolve(listedTask)
      return this.$http.get(`/chatApi/v1/web-scraper/tasks/${taskId}`)
        .then(res => res.data.data)
        .catch(() => null)
    },
    async bootstrapPage() {
      if (!this.hasStoredAuthSession()) return
      const authed = await this.ensureUserStatus({ prompt: false })
      if (!authed) return
      const tasks = await this.loadTasks()
      const storedContext = this.readTaskContext()
      this.recentTaskIds = storedContext.taskIds
      this.activeTaskContextId = storedContext.activeTaskId
      const runningTasks = this.latestRunningTasks(tasks)
      const restoreIds = Array.from(new Set([
        storedContext.activeTaskId,
        ...runningTasks.map(task => task.taskId),
        ...storedContext.taskIds,
      ].filter(Boolean).map(taskId => String(taskId)))).slice(0, 10)
      let restoreTasks = (await Promise.all(restoreIds.map(taskId => this.resolveTaskForBootstrap(taskId, tasks)))).filter(Boolean)
      if (!restoreTasks.length && tasks.length) restoreTasks = [this.latestTasks(tasks)[0]]
      if (!restoreTasks.length) return
      await Promise.all(restoreTasks.map(task => Promise.resolve(
        this.openTask(task, { workspaceTab: 'process', startPolling: false, persistContext: false })
      ).catch(() => undefined)))
      const restoredTaskIds = restoreTasks.map(task => String(task.taskId))
      const preferredTaskId = [
        storedContext.activeTaskId,
        runningTasks.length ? String(runningTasks[0].taskId) : '',
        restoredTaskIds[0],
      ].find(taskId => taskId && restoredTaskIds.includes(taskId))
      const preferredTarget = this.targets.find(target => String(target.taskId) === preferredTaskId)
      if (preferredTarget) this.selectTarget(preferredTarget, { persistContext: false })
      this.activeWorkspaceTab = preferredTarget && ['PENDING', 'RUNNING'].includes(preferredTarget.status) ? 'process' : 'results'
      this.setMobileWorkspacePane('analysis')
      this.recentTaskIds = Array.from(new Set([preferredTaskId, ...restoredTaskIds, ...storedContext.taskIds].filter(Boolean))).slice(0, 10)
      this.activeTaskContextId = preferredTaskId || this.recentTaskIds[0] || ''
      this.persistTaskContext()
      if (this.runningTargets.length) this.startPolling()
    },
    hasStoredAuthSession() {
      const token = localStorage.getItem('token')
      const authContext = localStorage.getItem('auth-context')
      if (!token || !authContext) return false
      try {
        const identities = JSON.parse(authContext)
        return Array.isArray(identities) && identities.length > 0
      } catch (e) {
        return false
      }
    },
    async ensureUserStatus({ prompt = true } = {}) {
      try {
        const response = await authServiceClient.getUserStatus(userStatusRequest, this.getMetadata())
        if (!response.getStatus()) { this.clearAuthStorage(); if (prompt) this.openLoginDialog(); return false }
      } catch (e) { this.clearAuthStorage(); if (prompt) this.openLoginDialog(); return false }
      if (!localStorage.getItem('auth-context')) { if (prompt) this.openLoginDialog(); return false }
      this.syncUserInfoFromStorage()
      return true
    },
    clearAuthStorage() {
      localStorage.removeItem('token')
      localStorage.removeItem('auth-context')
      this.clearTaskContext()
      this.userInfo = ''
    },
    openLoginDialog() {
      if (this.loginLayerIndex !== null && this.loginLayerIndex !== undefined) return
      this.$nextTick(() => {
        if (this.loginLayerIndex === null || this.loginLayerIndex === undefined) {
          this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL || '/login')
        }
      })
    },
    handleWorkspaceFocus(event) {
      const target = event && event.target
      if (!target || !['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName)) return
      if (this.hasStoredAuthSession()) return
      this.openLoginDialog()
    },
    setMobileWorkspacePane(pane) {
      this.mobileWorkspacePane = pane === 'analysis' ? 'analysis' : 'settings'
      if (!window.matchMedia('(max-width: 768px)').matches) return
      this.$nextTick(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      })
    },
    resolveRpcErrorMessage(error, fallbackMessage) {
      if (!error) return fallbackMessage
      const metadata = error.metadata || {}
      const candidates = [error.message, metadata['grpc-message'], metadata.message, metadata.details]
      for (let item of candidates) {
        if (Array.isArray(item)) item = item[0]
        if (item) return item
      }
      return fallbackMessage
    },
    async ensureScopeReady() {
      if (this.currentScopeId) return true
      const request = new RagBootstrapRequest()
      const response = await ragServiceClient.ragBootstrap(request, this.getMetadata())
      const personalScope = response.getScopesList()
        .map(scope => ({
          scopeId: scope.getScopeId ? scope.getScopeId() : '',
          scopeType: scope.getScopeType ? scope.getScopeType() : '',
        }))
        .find(scope => scope.scopeType === 'PERSONAL')
      this.currentScopeId = personalScope ? personalScope.scopeId : response.getDefaultScopeId()
      return !!this.currentScopeId
    },
    gotoPage(command) {
      const routeMap = {
        text: { path: '/translate', query: { type: 'text' } }, doc: { path: '/translate', query: { type: 'doc' } },
        ai: { path: '/translate', query: { type: 'AITranslate' } }, lange: { path: '/translate', query: { type: 'lange' } },
        polish: { path: '/translate', query: { type: 'polish' } }, aiPPT: { path: '/translate', query: { type: 'aiPPT' } },
        rag: { path: '/rag' },
      }
      if (routeMap[command]) this.$router.push(routeMap[command])
    },
    handleServiceCommand(command) {
      const routeMap = {
        toTransPro: '/trans-pro', standLangSet: '/license', convertDoc: '/convert', mySelfDoc: '/list',
        webTranslate: '/translate?type=web', smartClassify: '/smart-classify',
      }
      if (routeMap[command]) this.$router.push(routeMap[command])
    },
    handleUserCommand(command) {
      if (command === 'center') { window.open('https://user.wesitrans.com/account', '_blank'); return }
      if (command === 'logout') this.logout()
    },
    async logout() {
      try { outRequest.setName(''); await authServiceClient.logOut(outRequest, this.getMetadata()) } catch (e) {}
      this.clearAuthStorage()
      this.$router.push('/index')
    },
    syncUserInfoFromStorage() {
      const authContext = localStorage.getItem('auth-context')
      if (!authContext) { this.userInfo = ''; return }
      try {
        const users = JSON.parse(authContext)
        const mainUser = users.find(item => item.type === 'Person' || item.type === 'Child') || users[0]
        this.userInfo = mainUser ? (mainUser.realName ? Base64.decode(mainUser.realName) : mainUser.name) : ''
      } catch (e) { this.userInfo = '' }
    },
    handleStorageChange(event) {
      this.syncUserInfoFromStorage()
      if (!event || ['token', 'auth-context'].includes(event.key)) {
        if (!this.hasStoredAuthSession()) this.clearTaskContext()
        this.handleLoginSuccess()
      }
    },
    handleLoginMessage(event) {
      const data = event && event.data
      const action = typeof data === 'string' ? data : (data && (data.type || data.data))
      if (action === 'close') {
        this.stopLoginCheckTimer()
        this.closeLoginDialog(true)
        return
      }
      if (action === 'loginSuccess') {
        this.stopLoginCheckTimer()
        this.closeLoginDialog(true)
        window.setTimeout(() => this.handleLoginSuccess(), 300)
        return
      }
      if (action === 'register') {
        this.showIframe('/register')
      }
      if (action === 'params') {
        this.openLoginDialog()
      }
    },
    handleLoginSuccess() {
      this.syncUserInfoFromStorage()
      if (!this.userInfo && !localStorage.getItem('token')) return
      this.stopLoginCheckTimer()
      this.closeLoginDialog(true)
      this.loadTasks()
    },
    closeLoginDialog(forceAll = false) {
      this.$authPopup.close(this.loginLayerIndex)
      this.loginLayerIndex = null
    },
    startLoginCheckTimer() {
      this.stopLoginCheckTimer()
      this.loginAuthSnapshot = `${localStorage.getItem('token') || ''}|${localStorage.getItem('auth-context') || ''}`
      this.loginCheckTimer = window.setInterval(() => {
        const currentSnapshot = `${localStorage.getItem('token') || ''}|${localStorage.getItem('auth-context') || ''}`
        if (currentSnapshot !== '|' && currentSnapshot !== this.loginAuthSnapshot) {
          this.handleLoginSuccess()
        }
      }, 500)
    },
    stopLoginCheckTimer() {
      if (this.loginCheckTimer) {
        window.clearInterval(this.loginCheckTimer)
        this.loginCheckTimer = null
      }
      this.loginAuthSnapshot = ''
    },
    openSiteAuth(path) {
      if (window.matchMedia('(max-width: 768px)').matches) {
        this.$router.push(path === '/register' ? '/h5/register' : '/h5/login')
        return
      }
      this.showIframe(path)
    },
    showIframe(url) {
      const targetUrl = url === '/login' ? process.env.VUE_APP_WEB_LOGIN_URL || url : url
      if (this.loginLayerIndex !== null && this.loginLayerIndex !== undefined) {
        this.closeLoginDialog(true)
      }
      const index = this.$authPopup.open(targetUrl, {
        onClose: () => {
          this.stopLoginCheckTimer()
          this.loginLayerIndex = null
          this.syncUserInfoFromStorage()
          if (this.hasStoredAuthSession()) { this.loadTasks() }
        }
      })
      if (index === null) { this.$router.push(url); return }
      this.loginLayerIndex = index
      if (String(url).includes('/login') || String(url).includes('/register') || String(targetUrl).includes('/login')) {
        this.startLoginCheckTimer()
      }
    },
    openExternalUrl(url) {
      if (!url) { this.$message.warning('暂无可跳转的网页地址'); return }
      let targetUrl
      try { targetUrl = new URL(url) } catch (e) { this.$message.error('网页地址格式不正确'); return }
      if (!['http:', 'https:'].includes(targetUrl.protocol)) { this.$message.error('仅支持打开 http/https 网页地址'); return }
      const safeUrl = targetUrl.href.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;')
      this.$confirm(
        `<div class="external-confirm-content"><span class="external-confirm-icon">!</span><div class="external-confirm-body"><p>您即将离开微思翻译，请注意您的账号和财产安全。</p><p class="external-confirm-url">${safeUrl}</p></div></div>`,
        '即将离开微思翻译',
        { dangerouslyUseHTMLString: true, confirmButtonText: '继续跳转', cancelButtonText: '取消', type: 'warning', customClass: 'smart-external-confirm', confirmButtonClass: 'smart-external-confirm-btn' }
      ).then(() => { window.open(targetUrl.href, '_blank', 'noopener,noreferrer') }).catch(() => {})
    },
    createTarget(source = {}) {
      const id = this.nextTargetId++
      return {
        id,
        url: source.url || '',
        keywords: this.parseKeywordList(source.keywords || []),
        keywordInput: '',
        taskId: source.taskId || '',
        task: source.task || null,
        pages: source.pages || [],
        progress: source.progress || 0,
        status: source.status || 'IDLE',
        lastStatus: source.status || 'IDLE',
        lastProgressMessage: source.progressMessage || '',
        logs: source.logs || [],
        logCursor: source.logCursor || '',
        logsLoaded: !!source.logsLoaded,
        logDisplayVersion: source.logDisplayVersion || 0,
      }
    },
    addTarget() {
      if (this.targets.length >= 10) {
        this.$message.warning('最多添加10个目标网址')
        return
      }
      const target = this.createTarget()
      this.targets.push(target)
      this.selectTarget(target)
    },
    trackAddTarget() {
      trackElementClick({
        eventName: 'element_click',
        trackId: 'smart_classify.add_target',
        text: '添加网址',
        type: 'button',
        tag: 'button',
        componentName: 'SmartClassify',
        businessId: 'add_target',
      }, {
        trackSource: 'method_trackAddTarget',
      })
      this.addTarget()
    },
    removeTarget(id) {
      if (this.targets.length <= 1) {
        const target = this.targets[0]
        const removedTaskId = target.taskId
        this.invalidateTaskRequests(target.taskId)
        this.$set(target, 'url', '')
        this.$set(target, 'keywords', [])
        this.$set(target, 'keywordInput', '')
        this.$set(target, 'taskId', '')
        this.$set(target, 'task', null)
        this.$set(target, 'pages', [])
        this.$set(target, 'progress', 0)
        this.$set(target, 'status', 'IDLE')
        this.$set(target, 'lastStatus', 'IDLE')
        this.$set(target, 'lastProgressMessage', '')
        this.$set(target, 'logs', [])
        this.$set(target, 'logCursor', '')
        this.$set(target, 'logsLoaded', false)
        this.$set(target, 'logDisplayVersion', (target.logDisplayVersion || 0) + 1)
        this.currentTask = null
        this.pages = []
        this.forgetTaskContext(removedTaskId)
        return
      }
      const index = this.targets.findIndex(target => target.id === id)
      if (index < 0) return
      const removedTaskId = this.targets[index].taskId
      this.invalidateTaskRequests(this.targets[index].taskId)
      this.targets.splice(index, 1)
      if (this.activeTargetId === id) {
        this.selectTarget(this.targets[Math.max(0, index - 1)] || this.targets[0])
      }
      this.forgetTaskContext(removedTaskId)
    },
    selectTarget(target, options = {}) {
      if (!target) return
      this.activeTargetId = target.id
      this.currentTask = target.task || null
      this.pages = target.pages || []
      if (this.activeResultTab !== 'all' && !this.matchedPages.some((item, index) => this.activeResultTab === this.pageTabName(item, index))) {
        this.activeResultTab = 'all'
      }
      if (options.persistContext !== false && target.taskId) this.rememberTaskContext(target.taskId)
    },
    addTargetKeyword(target) {
      if (!target) return
      const inputKeywords = this.parseKeywordList(target.keywordInput)
      if (!inputKeywords.length) {
        this.$message.warning('请输入锚点词')
        return
      }
      const merged = Array.from(new Set([...(target.keywords || []), ...inputKeywords]))
      if (merged.length > 5) {
        this.$message.warning('每个网址最多添加5个锚点词')
      }
      this.$set(target, 'keywords', merged.slice(0, 5))
      this.$set(target, 'keywordInput', '')
    },
    removeTargetKeyword(target, keyword) {
      if (!target) return
      this.$set(target, 'keywords', (target.keywords || []).filter(item => item !== keyword))
    },
    historyKeywords(task) {
      return this.parseKeywordList(task && task.keywords).slice(0, 5)
    },
    historyKeywordTitle(task) {
      return this.parseKeywordList(task && task.keywords).join('、')
    },
    targetStatusText(target) {
      if (!target) return '待机'
      return target.status === 'IDLE' ? '待机' : this.statusText(target.status)
    },
    latestTasks(tasks = []) {
      return tasks
        .filter(Boolean)
        .sort((left, right) => {
          const leftTime = Date.parse(String(left.createTime || left.startTime || '').replace(' ', 'T')) || Number(left.id) || 0
          const rightTime = Date.parse(String(right.createTime || right.startTime || '').replace(' ', 'T')) || Number(right.id) || 0
          return rightTime - leftTime
        })
    },
    latestRunningTasks(tasks = []) {
      return this.latestTasks(tasks).filter(task => ['PENDING', 'RUNNING'].includes(task.status))
    },
    clearLogs() {
      const target = this.selectedTarget
      if (!target) return
      this.$set(target, 'logs', [])
      this.$set(target, 'logDisplayVersion', (target.logDisplayVersion || 0) + 1)
    },
    publicDisplayText(value) {
      return String(value || '')
        .replace(/hermes\s*模型/gi, 'AI模型')
        .replace(/hermes\s*服务/gi, '抓取服务')
        .replace(/hermes\s*[:：]\s*/gi, '')
        .replace(/hermes/gi, '智能抓取')
    },
    appendLog(message, type = 'info', target = this.selectedTarget, options = {}) {
      if (!target) return
      const now = new Date()
      const time = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`
      const logs = Array.isArray(target.logs) ? target.logs.slice() : []
      const displayMessage = this.publicDisplayText(message)
      if (options.skipDuplicate && logs.some(log => log.message === displayMessage)) return
      logs.unshift({
        id: `local-${Date.now()}-${Math.random()}`,
        time,
        type,
        message: displayMessage,
        createTime: now.toISOString(),
        local: true,
        summary: !!options.summary,
      })
      this.$set(target, 'logs', logs.slice(0, 200))
    },
    compareLogIds(left, right) {
      const a = String(left === undefined || left === null ? '' : left)
      const b = String(right === undefined || right === null ? '' : right)
      if (!a) return b ? -1 : 0
      if (!b) return 1
      if (/^\d+$/.test(a) && /^\d+$/.test(b)) {
        if (a.length !== b.length) return a.length > b.length ? 1 : -1
      }
      return a === b ? 0 : (a > b ? 1 : -1)
    },
    formatLogTime(createTime) {
      const text = String(createTime || '')
      const matched = text.match(/[T\s](\d{2}:\d{2}:\d{2})/)
      if (matched) return matched[1]
      const date = new Date(text)
      if (!Number.isNaN(date.getTime())) {
        return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`
      }
      return '--:--:--'
    },
    persistedLogType(level) {
      const value = String(level || '').toUpperCase()
      if (['ERROR', 'FAILED', 'FAIL'].includes(value)) return 'error'
      if (['WARN', 'WARNING'].includes(value)) return 'warning'
      if (['SUCCESS', 'SUCCEEDED'].includes(value)) return 'success'
      return 'info'
    },
    normalizePersistedLog(raw, taskId) {
      if (!raw) return null
      const serverId = raw.id === undefined || raw.id === null ? '' : String(raw.id)
      const createTime = raw.createTime || ''
      const message = this.publicDisplayText(raw.message)
      if (!message) return null
      return {
        ...raw,
        id: serverId ? `server-${taskId}-${serverId}` : `server-${taskId}-${createTime}-${message}`,
        serverId,
        time: this.formatLogTime(createTime),
        type: this.persistedLogType(raw.level),
        message,
        createTime,
        persisted: true,
      }
    },
    logSortValue(log) {
      const parsed = Date.parse(String((log && log.createTime) || '').replace(' ', 'T'))
      return Number.isNaN(parsed) ? 0 : parsed
    },
    mergeTargetLogs(target, incoming) {
      if (!target || !incoming.length) return
      const normalized = incoming.map(item => this.normalizePersistedLog(item, target.taskId)).filter(Boolean)
      if (!normalized.length) return
      const current = (target.logs || []).filter(log => {
        if (log.summary) return false
        if (!log.local) return true
        return !normalized.some(item => (
          item.message === log.message ||
          log.message.endsWith(`：${item.message}`) ||
          item.message.endsWith(`：${log.message}`)
        ))
      })
      const byId = new Map()
      current.concat(normalized).forEach(log => byId.set(log.id, log))
      const merged = Array.from(byId.values()).sort((left, right) => {
        const timeDiff = this.logSortValue(right) - this.logSortValue(left)
        if (timeDiff) return timeDiff
        return this.compareLogIds(right.serverId, left.serverId)
      })
      this.$set(target, 'logs', merged.slice(0, 200))
    },
    loadTaskLogs(target = this.selectedTarget) {
      const taskId = target && target.taskId ? target.taskId : this.currentTask && this.currentTask.taskId
      if (!taskId) return Promise.resolve([])
      if (this.logLoadPromises[taskId]) return this.logLoadPromises[taskId]
      const targetToLoad = this.targets.find(item => item.taskId === taskId) || target
      if (!targetToLoad || targetToLoad.taskId !== taskId) return Promise.resolve([])
      const initialLoad = !targetToLoad.logsLoaded
      const cursor = targetToLoad.logCursor
      const displayVersion = targetToLoad.logDisplayVersion || 0
      const params = initialLoad
        ? { current: 1, size: 200 }
        : { afterId: cursor || undefined, size: 200 }
      const request = this.$http.get(`/chatApi/v1/web-scraper/tasks/${taskId}/logs`, { params }).then((res) => {
        const currentTarget = this.targets.find(item => item.taskId === taskId)
        if (!currentTarget || currentTarget.taskId !== taskId) return []
        const data = res.data.data || []
        const records = Array.isArray(data) ? data : (data.records || [])
        let nextCursor = currentTarget.logCursor || ''
        records.forEach(log => {
          if (log && log.id !== undefined && log.id !== null && this.compareLogIds(log.id, nextCursor) > 0) {
            nextCursor = String(log.id)
          }
        })
        this.$set(currentTarget, 'logCursor', nextCursor)
        this.$set(currentTarget, 'logsLoaded', true)
        if ((currentTarget.logDisplayVersion || 0) === displayVersion) {
          this.mergeTargetLogs(currentTarget, records)
          if (initialLoad && !records.length && !(currentTarget.logs || []).length && currentTarget.task && currentTarget.task.progressMessage) {
            this.appendLog(
              `${this.decodeUrl(currentTarget.url)}：${currentTarget.task.progressMessage}`,
              currentTarget.task.status === 'FAILED' ? 'error' : 'info',
              currentTarget,
              { summary: true, skipDuplicate: true }
            )
          }
        }
        return records
      })
      this.$set(this.logLoadPromises, taskId, request)
      const clearRequest = () => {
        if (this.logLoadPromises[taskId] === request) this.$delete(this.logLoadPromises, taskId)
      }
      request.then(clearRequest, clearRequest)
      return request
    },
    refreshTerminalTaskLogs(target, taskId) {
      const inFlightRequest = this.logLoadPromises[taskId]
      return Promise.resolve(inFlightRequest || [])
        .catch(() => [])
        .then(() => {
          // 终态任务必须在上一轮日志请求真正结束后再发起一次增量请求。
          // 否则 loadTaskLogs 会复用旧 Promise，仍可能漏掉刚写入 Redis 的 COMPLETE/FAILED。
          if (inFlightRequest && this.logLoadPromises[taskId] === inFlightRequest) {
            this.$delete(this.logLoadPromises, taskId)
          }
          return this.loadTaskLogs(target).catch(() => [])
        })
    },
    getHttpErrorMessage(err, fallback) {
      const message = (err && err.response && err.response.data && (err.response.data.msg || err.response.data.message)) || fallback
      return this.publicDisplayText(message)
    },
    invalidateTaskRequests(taskId) {
      if (!taskId) return
      this.taskRequestVersions[taskId] = (this.taskRequestVersions[taskId] || 0) + 1
      this.pageRequestVersions[taskId] = (this.pageRequestVersions[taskId] || 0) + 1
    },
    applyTaskToTarget(target, task, options = {}) {
      if (!target || !task) return
      const status = task.status || target.status || 'PENDING'
      const previousStatus = target.status
      this.$set(target, 'task', task)
      this.$set(target, 'taskId', task.taskId || target.taskId)
      this.$set(target, 'url', task.startUrl || target.url)
      this.$set(target, 'progress', task.progress || 0)
      this.$set(target, 'status', status)
      const keywords = this.parseKeywordList(task.keywords || target.keywords)
      if (keywords.length) this.$set(target, 'keywords', keywords.slice(0, 5))
      if (options.logStatus && !target.logsLoaded && previousStatus !== status) {
        this.appendLog(`${this.decodeUrl(target.url)}：${this.statusText(status)}`, status === 'FAILED' ? 'error' : 'success', target, { skipDuplicate: true })
      }
      if (options.logStatus && !target.logsLoaded && task.progressMessage && target.lastProgressMessage !== task.progressMessage) {
        this.appendLog(`${this.decodeUrl(target.url)}：${task.progressMessage}`, 'info', target, { skipDuplicate: true })
      }
      this.$set(target, 'lastProgressMessage', task.progressMessage || '')
      this.$set(target, 'lastStatus', status)
      if (target.id === this.activeTargetId) {
        this.currentTask = task
      }
    },
    async submitTarget(target, options = {}) {
      this.invalidateTaskRequests(target && target.taskId)
      this.$set(target, 'logs', [])
      this.$set(target, 'logCursor', '')
      this.$set(target, 'logsLoaded', false)
      this.$set(target, 'logDisplayVersion', (target.logDisplayVersion || 0) + 1)
      this.$set(target, 'status', 'PENDING')
      this.$set(target, 'progress', 0)
      this.$set(target, 'pages', [])
      this.$set(target, 'task', null)
      this.$set(target, 'taskId', '')
      this.$set(target, 'lastProgressMessage', '')
      if (target.id === this.activeTargetId) {
        this.currentTask = null
        this.pages = []
      }
      this.appendLog(`${options.retry ? '重新提交' : '提交'}：${this.decodeUrl(target.url)}`, 'info', target)
      const res = await this.$http.post('/chatApi/v1/web-scraper/tasks', {
        startUrl: target.url,
        keywords: target.keywords,
        maxDepth: CRAWL_MAX_DEPTH,
        maxPages: CRAWL_MAX_PAGES,
        scheduleMode: this.form.scheduleMode,
        intervalMinutes: this.form.intervalMinutes,
        scheduleTime: this.form.scheduleTime,
        autoImportRag: this.form.autoImportRag,
        complianceConfirmed: this.form.complianceConfirmed,
        policyVersion: this.form.policyVersion,
      })
      const task = res.data.data
      this.applyTaskToTarget(target, task)
      if (task && task.taskId) {
        this.rememberTaskContext(task.taskId, { active: target.id === this.activeTargetId })
        if (this.form.autoImportRag) {
          this.$set(this.autoExportTaskIds, task.taskId, true)
        }
        this.appendLog(`任务已创建：${task.taskId}`, 'success', target)
        if (this.form.autoImportRag) {
          this.appendLog('已开启自动导入RAG，任务完成后会写入报告和下载文件', 'info', target)
        }
      }
      if (target.id === this.activeTargetId) {
        this.currentTask = task
        this.activeResultTab = 'all'
      }
    },
    async submitBatch() {
      if (!this.hasStoredAuthSession()) { this.openLoginDialog(); return }
      if (!this.form.complianceConfirmed) { this.$message.error('请先勾选合规声明'); return }
      const readyTargets = this.targets.filter(target => String(target.url || '').trim())
      if (!readyTargets.length) { this.$message.error('请至少输入一个目标网址'); return }
      const missingKeywordTarget = readyTargets.find(target => !target.keywords || !target.keywords.length)
      if (missingKeywordTarget) {
        this.selectTarget(missingKeywordTarget)
        this.$message.error('每个目标网址至少需要一个锚点词')
        return
      }
      this.submitting = true
      this.activeWorkspaceTab = 'process'
      this.clearLogs()
      try {
        for (const target of readyTargets) {
          try {
            await this.submitTarget(target)
          } catch (err) {
            this.$set(target, 'status', 'FAILED')
            this.$set(target, 'progress', 0)
            this.appendLog(`${this.decodeUrl(target.url)}：${this.getHttpErrorMessage(err, '提交失败')}`, 'error', target)
          }
        }
        this.loadTasks()
        if (this.runningTargets.length) this.startPolling()
        else this.stopPolling()
        this.$message.success('抓取任务已提交')
        this.setMobileWorkspacePane('analysis')
      } finally {
        this.submitting = false
      }
    },
    submitTask() {
      return this.submitBatch()
    },
    async retryTask() {
      if (!this.hasStoredAuthSession()) { this.openLoginDialog(); return }
      if (!this.currentTask) return
      const target = this.selectedTarget || this.createTarget()
      const keywords = this.parseKeywordList(target.keywords && target.keywords.length ? target.keywords : this.currentTask.keywords)
      if (!keywords.length) { this.$message.error('当前任务缺少锚点词，无法重试'); return }
      const url = target.url || this.currentTask.startUrl
      if (!url) { this.$message.error('当前任务缺少网页地址，无法重试'); return }
      this.$set(target, 'url', url)
      this.$set(target, 'keywords', keywords.slice(0, 5))
      this.submitting = true
      try {
        await this.submitTarget(target, { retry: true })
        this.loadTasks()
        this.startPolling()
        this.$message.success('已重新提交分析任务')
      } catch (err) {
        this.$message.error(this.getHttpErrorMessage(err, '重试失败'))
      } finally {
        this.submitting = false
      }
    },
    async cancelTask() {
      if (!this.currentTask || !this.canCancelTask(this.currentTask)) return
      const taskId = this.currentTask.taskId
      try {
        await this.$confirm('确认取消抓取任务？当前浏览器抓取会停止，已保存的数据不会删除；定时任务也将停止后续调度。', '取消抓取', {
          confirmButtonText: '确认取消',
          cancelButtonText: '继续执行',
          type: 'warning',
        })
      } catch (e) {
        return
      }
      this.cancellingTaskId = taskId
      this.invalidateTaskRequests(taskId)
      try {
        const res = await this.$http.post(`/chatApi/v1/web-scraper/tasks/${taskId}/cancel`)
        this.invalidateTaskRequests(taskId)
        const task = res.data.data
        const target = this.targets.find(item => item.taskId === taskId) || this.selectedTarget
        this.applyTaskToTarget(target, task, { logStatus: true })
        this.appendLog(`${this.decodeUrl(task.startUrl)}：抓取任务已取消`, 'warning', target)
        if (!this.runningTargets.length) this.stopPolling()
        this.$message.success('抓取任务已取消')
      } catch (err) {
        this.$message.error(this.getHttpErrorMessage(err, '取消任务失败'))
      } finally {
        this.cancellingTaskId = ''
      }
    },
    async loadTasks() {
      if (!this.hasStoredAuthSession()) {
        this.openLoginDialog()
        return []
      }
      try {
        const res = await this.$http.get('/chatApi/v1/web-scraper/tasks', { params: { current: 1, size: 20 } })
        const data = res.data.data || {}
        this.tasks = data.records || []
        return this.tasks
      } catch (e) {
        return this.tasks || []
      }
    },
    openTask(task, options = {}) {
      let target = this.targets.find(item => item.taskId === task.taskId)
      if (!target) {
        target = this.targets.find(item => !item.url && !item.taskId)
      }
      if (!target) {
        if (this.targets.length < 10) {
          target = this.createTarget()
          this.targets.push(target)
        } else {
          target = this.selectedTarget
          this.appendLog('目标数量已满，使用当前目标卡片展示历史任务', 'warning', target)
        }
      }
      if (target.taskId && target.taskId !== task.taskId) {
        this.invalidateTaskRequests(target.taskId)
        this.$set(target, 'pages', [])
        this.$set(target, 'logs', [])
        this.$set(target, 'logCursor', '')
        this.$set(target, 'logsLoaded', false)
        this.$set(target, 'logDisplayVersion', (target.logDisplayVersion || 0) + 1)
      }
      this.applyTaskToTarget(target, task)
      this.selectTarget(target, { persistContext: options.persistContext !== false })
      this.pageQuery.current = 1
      this.activeResultTab = 'all'
      this.activeWorkspaceTab = options.workspaceTab || 'results'
      const request = this.loadTask(target)
      this.setMobileWorkspacePane('analysis')
      if (options.startPolling !== false && ['PENDING', 'RUNNING'].includes(task.status)) this.startPolling()
      return request
    },
    loadTask(target = this.selectedTarget) {
      const taskId = target && target.taskId ? target.taskId : this.currentTask && this.currentTask.taskId
      if (!taskId) return Promise.resolve()
      this.loadTaskLogs(target).catch(() => {})
      if (this.taskLoadPromises[taskId]) return this.taskLoadPromises[taskId]
      const requestVersion = (this.taskRequestVersions[taskId] || 0) + 1
      this.taskRequestVersions[taskId] = requestVersion
      const request = this.$http.get(`/chatApi/v1/web-scraper/tasks/${taskId}`).then((res) => {
        if (this.taskRequestVersions[taskId] !== requestVersion) return undefined
        const task = res.data.data
        const targetToUpdate = this.targets.find(item => item.taskId === taskId) || target
        if (!targetToUpdate || !this.targets.includes(targetToUpdate) || targetToUpdate.taskId !== taskId) return undefined
        this.applyTaskToTarget(targetToUpdate, task, { logStatus: true })
        const onPagesLoaded = () => {
          if (this.taskRequestVersions[taskId] !== requestVersion) return
          if (!['PENDING', 'RUNNING'].includes(task.status)) {
            if (targetToUpdate && targetToUpdate.id === this.activeTargetId) {
              this.autoExportToRagIfNeeded()
            }
          }
        }
        const terminalTask = !['PENDING', 'RUNNING'].includes(task.status)
        const terminalLogsReady = terminalTask
          ? this.refreshTerminalTaskLogs(targetToUpdate, taskId)
          : Promise.resolve([])
        return terminalLogsReady.then(() => this.loadPages(targetToUpdate, { force: terminalTask })).then(onPagesLoaded).catch((err) => {
          if (terminalTask && this.taskRequestVersions[taskId] === requestVersion) {
            window.setTimeout(() => {
              if (this.taskRequestVersions[taskId] !== requestVersion || !this.targets.includes(targetToUpdate)) return
              this.loadPages(targetToUpdate).then(onPagesLoaded).catch(retryErr => {
                this.appendLog(`${this.decodeUrl(targetToUpdate.url)}：${this.getHttpErrorMessage(retryErr, '最终页面结果加载失败，请手动刷新')}`, 'error', targetToUpdate)
              })
            }, 1000)
          }
          throw err
        })
      })
      this.taskLoadPromises[taskId] = request
      const clearRequest = () => {
        if (this.taskLoadPromises[taskId] === request) delete this.taskLoadPromises[taskId]
      }
      request.then(clearRequest, clearRequest)
      return request
    },
    loadPages(target = this.selectedTarget, options = {}) {
      const taskId = target && target.taskId ? target.taskId : this.currentTask && this.currentTask.taskId
      if (!taskId) return Promise.resolve()
      if (this.pageLoadPromises[taskId] && !options.force) return this.pageLoadPromises[taskId]
      const requestVersion = (this.pageRequestVersions[taskId] || 0) + 1
      this.pageRequestVersions[taskId] = requestVersion
      const request = this.$http.get(`/chatApi/v1/web-scraper/tasks/${taskId}/pages`, {
        params: { ...this.pageQuery },
      }).then((res) => {
        if (this.pageRequestVersions[taskId] !== requestVersion) return undefined
        const data = res.data.data || {}
        const records = data.records || []
        const targetToUpdate = this.targets.find(item => item.taskId === taskId) || null
        if (target && !targetToUpdate) return undefined
        if (targetToUpdate) this.$set(targetToUpdate, 'pages', records)
        if (!targetToUpdate || targetToUpdate.id === this.activeTargetId || taskId === (this.currentTask && this.currentTask.taskId)) {
          this.pages = records
          this.pageTotal = data.total || 0
          if (this.activeResultTab !== 'all' && !this.matchedPages.some((item, index) => this.activeResultTab === this.pageTabName(item, index))) {
            this.activeResultTab = 'all'
          }
        }
      })
      this.pageLoadPromises[taskId] = request
      const clearRequest = () => {
        if (this.pageLoadPromises[taskId] === request) delete this.pageLoadPromises[taskId]
      }
      request.then(clearRequest, clearRequest)
      return request
    },
    pollTargets() {
      const runningTargets = this.runningTargets.slice()
      if (!runningTargets.length) {
        this.stopPolling()
        return
      }
      runningTargets.forEach(target => {
        this.loadTask(target).catch(err => {
          this.appendLog(`${this.decodeUrl(target.url)}：${this.getHttpErrorMessage(err, '轮询失败')}`, 'error', target, { skipDuplicate: true })
        })
      })
    },
    startPolling() {
      this.stopPolling()
      this.pollTargets()
      this.pollTimer = window.setInterval(() => { this.pollTargets() }, 3000)
    },
    stopPolling() {
      if (this.pollTimer) { window.clearInterval(this.pollTimer); this.pollTimer = null }
    },
    statusText(status) {
      const map = {
        IDLE: '待机',
        PENDING: '等待中',
        RUNNING: '处理中',
        SUCCESS: '已完成',
        FAILED: '失败',
        CANCELLED: '已取消',
        CLASSIFY_FAILED: '分析失败',
      }
      return map[status] || status || '未知'
    },
    taskRunStateText(status) {
      return ['PENDING', 'RUNNING'].includes(status) ? '执行中' : '待机'
    },
    taskRagName(task) {
      if (!task || !task.reportRagId) return ''
      return task.reportRagName || task.reportRagId
    },
    taskAutoImportRag(task) {
      return !!(task && (task.autoImportRag === true || task.autoImportRag === 1 || task.autoImportRag === '1'))
    },
    showManualRagImportButton(task) {
      return !!(task && task.status === 'SUCCESS' && !task.reportRagId && !this.taskAutoImportRag(task))
    },
    statusType(status) {
      if (status === 'SUCCESS') return 'success'
      if (['FAILED', 'CLASSIFY_FAILED'].includes(status)) return 'danger'
      if (status === 'RUNNING') return 'warning'
      return 'info'
    },
    progressStageText(stage) {
      const map = {
        QUEUED: '等待执行',
        ROBOTS_CHECK: '合规检查',
        HERMES_RUNNING: '智能抓取中',
        PAGE_OPEN: '打开页面',
        PAGE_RENDER: '页面渲染',
        PAGE_DISCOVERY: '发现页面',
        BROWSER_TOOL: '浏览器执行',
        BROWSER_TOOL_COMPLETE: '浏览器步骤完成',
        BROWSER_TOOL_FAILED: '浏览器恢复',
        RUN_RECONNECT: '断线续查',
        RUN_RETRY: '会话重试',
        PAGE_RETRY: '页面重试',
        CRAWL_COMPLETE: '抓取完成',
        PAGE_ANALYZE: '内容分析',
        COMPLETE: '已完成',
        CANCELLED: '已取消',
        FAILED: '执行失败',
      }
      return map[stage] || '任务进度'
    },
    canCancelTask(task) { return !!(task && ['PENDING', 'RUNNING'].includes(task.status)) },
    canRetryTask(task) { return task && task.status === 'FAILED' },
    emptyResultText(task) {
      const status = task && task.status
      if (status === 'CANCELLED') return '任务已取消，暂无已保存页面'
      if (['FAILED', 'CLASSIFY_FAILED'].includes(status)) return '任务执行失败，暂无已保存页面'
      return '暂无结果'
    },
    pageTabName(page, index) {
      if (page && page.id !== undefined && page.id !== null && page.id !== '') return `page-id-${page.id}`
      if (page && page.url) return `page-url-${page.url}`
      return `page-index-${index}`
    },
    pageTabTitle(page, index) {
      return (page && (page.title || page.originalTitle)) || `页面${index + 1}`
    },
    pageReportTitle(page) {
      const host = this.siteName(this.currentTask && this.currentTask.startUrl)
      const keyword = this.pageKeywordText(page)
      return this.isPageMatched(page)
        ? `${host || '网页'}“${keyword}”相关内容抓取报告`
        : `${host || '网页'}未命中关键词页面记录`
    },
    siteName(url) {
      if (!url) return ''
      try {
        return new URL(url).hostname.replace(/^www\./, '')
      } catch (e) {
        return this.decodeUrl(url)
      }
    },
    matchedPageClassifications(page) {
      const list = page && Array.isArray(page.classifications) ? page.classifications : []
      return list.filter(item => item && item.exactMatched === true)
    },
    normalizeMatchedKeywords(value) {
      if (!Array.isArray(value)) return []
      return Array.from(new Set(value.map(item => String(item || '').trim()).filter(Boolean)))
    },
    pageExactMatchedKeywords(page) {
      const stored = this.normalizeMatchedKeywords(page && page.exactMatchedKeywords)
      if (stored.length) return stored
      return this.normalizeMatchedKeywords(this.matchedPageClassifications(page).map(item => item.keyword))
    },
    pageMatchedKeywords(page) {
      return this.pageExactMatchedKeywords(page)
    },
    isPageMatched(page) {
      return this.pageExactMatchedKeywords(page).length > 0
    },
    pageMatchDescription(page) {
      return this.isPageMatched(page) ? '精确命中' : '未精确命中'
    },
    pageMatchMarkText(page) {
      return this.isPageMatched(page) ? '精确' : '未中'
    },
    pageMatchMarkClass(page) {
      return {
        exact: this.isPageMatched(page),
        miss: !this.isPageMatched(page),
      }
    },
    pageKeywordText(page) {
      return this.pageMatchedKeywords(page).join('、') || '未命中'
    },
    pageMatchedCount(page) {
      return this.pageMatchedKeywords(page).length
    },
    pageDateText(page) {
      return page && page.publishDate ? `（截至 ${page.publishDate}）` : ''
    },
    pageDateRange(page) {
      return page && page.publishDate ? `${page.publishDate} ～ ${page.publishDate}` : '—'
    },
    pageThemeGroups(page) {
      const groups = []
      const groupMap = {}
      const matched = this.matchedPageClassifications(page)
      matched.forEach(item => {
        const theme = item.themeCategory || '内容摘要'
        if (!groupMap[theme]) {
          groupMap[theme] = { theme, items: [] }
          groups.push(groupMap[theme])
        }
        groupMap[theme].items.push({
          keyword: item.keyword || '关键词',
          summary: item.summary || '',
          evidences: Array.isArray(item.evidences) ? item.evidences : [],
        })
      })
      if (!groups.length && page && page.contentSummary) {
        groups.push({
          theme: this.isPageMatched(page) ? '内容摘要' : '未命中页面摘要',
          items: [{ keyword: this.pageKeywordText(page), summary: page.contentSummary, evidences: [] }],
        })
      }
      return groups
    },
    pageKnowledgeGraph(page) {
      if (!page) return { nodes: [], edges: [] }
      if (page.knowledgeGraph && Array.isArray(page.knowledgeGraph.nodes) && Array.isArray(page.knowledgeGraph.edges)) {
        return page.knowledgeGraph
      }
      if (page.graphJson) {
        try {
          const graph = JSON.parse(page.graphJson)
          return {
            nodes: Array.isArray(graph.nodes) ? graph.nodes : [],
            edges: Array.isArray(graph.edges) ? graph.edges : [],
          }
        } catch (e) {
          return { nodes: [], edges: [] }
        }
      }
      return { nodes: [], edges: [] }
    },
    pageGraphEdges(page) {
      return this.pageKnowledgeGraph(page).edges || []
    },
    pageFiles(page) {
      return page && Array.isArray(page.files) ? page.files : []
    },
    pageFileCount(page) {
      return page && page.fileCount !== undefined && page.fileCount !== null ? page.fileCount : this.pageFiles(page).length
    },
    fileStatusText(status) {
      return status === 'SUCCESS' ? '已存储' : (status === 'FAILED' ? '失败' : status || '未知')
    },
    fileSizeText(size) {
      const value = Number(size || 0)
      if (!value) return '—'
      if (value < 1024) return `${value} B`
      if (value < 1024 * 1024) return `${(value / 1024).toFixed(1)} KB`
      return `${(value / 1024 / 1024).toFixed(1)} MB`
    },
    openFileLink(file) {
      if (!file) return
      const url = file.storageUrl || file.sourceUrl
      if (!url) {
        this.$message.warning('暂无可打开的文件地址')
        return
      }
      this.openExternalUrl(url)
    },
    graphNodeLabel(page, nodeId) {
      const graph = this.pageKnowledgeGraph(page)
      const matched = (graph.nodes || []).find(node => node.id === nodeId)
      if (!matched) return nodeId || ''
      return matched.labelEn ? `${matched.label} / ${matched.labelEn}` : matched.label
    },
    pageGraphLayout(page) {
      const graph = this.pageKnowledgeGraph(page)
      const rawNodes = (graph.nodes || []).filter(node => node && node.id)
      const rawEdges = graph.edges || []
      if (!rawNodes.length) return null

      const width = 900
      const height = 640
      const cx = width / 2
      const cy = height / 2

      // 统计度数，用于在缺少“主题”节点时挑选中心节点
      const degree = {}
      rawEdges.forEach(edge => {
        degree[edge.source] = (degree[edge.source] || 0) + 1
        degree[edge.target] = (degree[edge.target] || 0) + 1
      })

      let centerNode = rawNodes.find(node => /主题|theme|核心|core/i.test(node.type || ''))
      if (!centerNode) {
        centerNode = rawNodes.slice().sort((a, b) => (degree[b.id] || 0) - (degree[a.id] || 0))[0]
      }

      // 叶子节点按类型排序，使同色节点在环上相邻成簇
      const leaves = rawNodes
        .filter(node => node.id !== centerNode.id)
        .sort((a, b) => String(a.type || '').localeCompare(String(b.type || '')))

      const palette = ['#3aa0ff', '#36cfc9', '#73d13d', '#ffc53d', '#ff85c0', '#9254de', '#ff7a45', '#13c2c2', '#bae637', '#ffa940']
      const colorMap = {}
      let colorIdx = 0
      const colorOf = (type) => {
        const key = (type || '其它').trim() || '其它'
        if (/主题|theme|核心|core/i.test(key)) return '#e8443a'
        if (!colorMap[key]) {
          colorMap[key] = palette[colorIdx % palette.length]
          colorIdx += 1
        }
        return colorMap[key]
      }

      const maxWeight = Math.max(1, ...rawNodes.map(node => Number(node.weight) || 1))
      const radiusOf = (weight) => 7 + 9 * Math.sqrt((Number(weight) || 1) / maxWeight)

      const ringRadius = Math.min(width, height) / 2 - 170
      const positions = {}
      positions[centerNode.id] = { x: cx, y: cy }

      const nodes = [{
        x: cx,
        y: cy,
        r: Math.max(18, radiusOf(centerNode.weight) + 8),
        color: '#e8443a',
        center: true,
        label: centerNode.label || centerNode.id,
        labelEn: centerNode.labelEn || '',
        labelX: cx,
        anchor: 'middle',
        labelBelow: true,
      }]

      const total = leaves.length || 1
      leaves.forEach((node, i) => {
        const angle = (Math.PI * 2 * i) / total - Math.PI / 2
        const x = cx + ringRadius * Math.cos(angle)
        const y = cy + ringRadius * Math.sin(angle)
        positions[node.id] = { x, y }
        const onRight = Math.cos(angle) >= -0.01
        const r = radiusOf(node.weight)
        nodes.push({
          x,
          y,
          r,
          color: colorOf(node.type),
          center: false,
          label: node.label || node.id,
          labelEn: node.labelEn || '',
          labelX: onRight ? x + r + 6 : x - r - 6,
          anchor: onRight ? 'start' : 'end',
          labelBelow: false,
        })
      })

      const edges = []
      const linked = {}
      rawEdges.forEach(edge => {
        const source = positions[edge.source]
        const target = positions[edge.target]
        if (source && target) {
          edges.push({ x1: source.x, y1: source.y, x2: target.x, y2: target.y })
          linked[edge.source] = true
          linked[edge.target] = true
        }
      })
      // 没有显式边的叶子节点，默认连向中心，保证图谱连通
      leaves.forEach(node => {
        if (!linked[node.id]) {
          const point = positions[node.id]
          edges.push({ x1: cx, y1: cy, x2: point.x, y2: point.y })
        }
      })

      const legend = Object.keys(colorMap).map(type => ({ type, color: colorMap[type] }))

      return { width, height, nodes, edges, legend }
    },
    async downloadPageWord(page, index) {
      if (!page) return
      if (this.downloadPageIndex !== null) return
      this.downloadPageIndex = index
      try {
        const title = this.pageReportTitle(page)
        const doc = new Document({
          creator: 'Wesitrans',
          title,
          sections: [{
            properties: {},
            children: this.buildPageWordChildren(page),
          }],
        })
        const blob = await Packer.toBlob(doc)
        const fileName = `${this.sanitizeFileName(this.pageTabTitle(page, index))}.docx`
        this.triggerBlobDownload(blob, fileName)
        this.$message.success('Word文档已生成，开始下载')
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e)
        this.$message.error('下载Word文档失败')
      } finally {
        this.downloadPageIndex = null
      }
    },
    triggerBlobDownload(blob, fileName) {
      if (typeof window === 'undefined' || typeof document === 'undefined') {
        saveAs(blob, fileName)
        return
      }
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = fileName
      link.style.display = 'none'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.setTimeout(() => window.URL.revokeObjectURL(url), 1000)
    },
    buildPageWordChildren(page) {
      const children = [
        new Paragraph({ text: this.pageReportTitle(page), heading: HeadingLevel.TITLE }),
        new Paragraph({ text: '一、概况', heading: HeadingLevel.HEADING_2 }),
        this.wordParagraph(`抓取来源：${this.siteName(this.currentTask && this.currentTask.startUrl)}（${this.decodeUrl(this.currentTask && this.currentTask.startUrl)}）`),
        this.wordParagraph(`页面匹配：${this.pageMatchDescription(page)}`),
        this.wordParagraph(`精确命中关键词：${this.pageExactMatchedKeywords(page).join('、') || '—'}`),
        this.wordParagraph(`匹配条数：${this.pageMatchedCount(page)} 条${this.pageDateText(page)}`),
        this.wordParagraph(`时间跨度：${this.pageDateRange(page)}`),
        new Paragraph({ text: '二、抓取内容列表', heading: HeadingLevel.HEADING_2 }),
        this.wordTable([
          ['中文标题', '原标题', '发布时间', '链接'],
          [page.title || '—', page.originalTitle || '—', page.publishDate || '—', this.decodeUrl(page.url) || '—'],
        ]),
        new Paragraph({ text: '三、相关文件', heading: HeadingLevel.HEADING_2 }),
      ]
      const files = this.pageFiles(page)
      if (files.length) {
        children.push(this.wordTable([
          ['文件名', '类型', '大小', '状态', '地址'],
          ...files.map(file => [
            file.fileName || '—',
            file.fileExtension || file.contentType || '—',
            this.fileSizeText(file.fileSize),
            this.fileStatusText(file.status),
            this.decodeUrl(file.storageUrl || file.sourceUrl) || '—',
          ]),
        ]))
      } else {
        children.push(this.wordParagraph('暂无文件链接'))
      }
      children.push(new Paragraph({ text: '四、对链接内容的汇总', heading: HeadingLevel.HEADING_2 }))
      const groups = this.pageThemeGroups(page)
      if (groups.length) {
        groups.forEach((group, groupIndex) => {
          children.push(new Paragraph({ text: `${groupIndex + 1}、${group.theme}`, heading: HeadingLevel.HEADING_3 }))
          group.items.forEach(item => {
            children.push(this.wordParagraph(`${item.keyword}：${item.summary || page.contentSummary || '暂无摘要'}`))
            ;(item.evidences || []).forEach(evidence => {
              children.push(this.wordParagraph(`证据：${evidence}`))
            })
          })
        })
      } else {
        children.push(this.wordParagraph('暂无可汇总内容'))
      }
      children.push(new Paragraph({ text: '来源链接', heading: HeadingLevel.HEADING_2 }))
      children.push(this.wordParagraph(this.decodeUrl(page.url) || '—'))
      return children
    },
    wordParagraph(text) {
      return new Paragraph({
        children: [new TextRun({ text: String(text || '') })],
        spacing: { after: 160 },
      })
    },
    wordTable(rows) {
      return new Table({
        width: { size: 100, type: WidthType.PERCENTAGE },
        rows: rows.map((row, rowIndex) => new TableRow({
          children: row.map(cell => new TableCell({
            children: [new Paragraph({
              children: [new TextRun({ text: String(cell || ''), bold: rowIndex === 0 })],
            })],
          })),
        })),
      })
    },
    sanitizeFileName(value) {
      const name = String(value || '网页抓取报告').replace(/[\\/:*?"<>|]/g, '_').replace(/\s+/g, ' ').trim()
      return (name || '网页抓取报告').slice(0, 80)
    },

    // ── 导出报告 ───────────────────────────────────────────────────────────────
    async autoExportToRagIfNeeded() {
      if (!this.currentTask || this.currentTask.status !== 'SUCCESS') return
      if (this.currentTask.reportStatus === 'IMPORTING') {
        window.setTimeout(() => {
          if (this.currentTask && this.currentTask.taskId) this.loadTask()
        }, 2000)
        return
      }
      if (this.taskAutoImportRag(this.currentTask)) return
      if (!this.autoExportTaskIds[this.currentTask.taskId]) return
      if (this.currentTask.reportRagId || this.exporting) return
      window.setTimeout(async () => {
        if (!this.currentTask || this.currentTask.reportRagId || this.exporting) return
        await this.loadTask()
        if (this.currentTask && !this.currentTask.reportRagId && this.currentTask.status === 'SUCCESS') {
          await this.exportToRag({ silent: true })
        }
      }, 3000)
    },
    async exportToRag(options = {}) {
      if (!this.currentTask) return
      this.exporting = true
      try {
        const res = await this.$http.post(`/chatApi/v1/web-scraper/tasks/${this.currentTask.taskId}/export-to-rag`)
        const data = (res.data && res.data.data) || {}
        this.currentTask.reportRagId = data.ragId
        this.currentTask.reportRagName = data.ragName
        this.currentTask.reportStatus = data.status
        this.currentTask.reportDocumentName = data.documentName
        const target = this.targets.find(item => item.taskId === this.currentTask.taskId)
        if (target && target.task) {
          this.$set(target.task, 'reportRagId', data.ragId)
          this.$set(target.task, 'reportRagName', data.ragName)
          this.$set(target.task, 'reportStatus', data.status)
          this.$set(target.task, 'reportDocumentName', data.documentName)
        }
        this.loadTasks()
        if (!options.silent) {
          this.$message.success(`已写入RAG：${data.ragName || data.ragId || '-'}`)
        }
      } catch (e) {
        const message = this.getHttpErrorMessage(e, this.resolveRpcErrorMessage(e, e.message || '写入RAG失败，请稍后重试'))
        if (String(message || '').includes('RAG服务地址未配置')) {
          try {
            await this.exportToRagViaBrowser(options)
          } catch (fallbackError) {
            this.$message.error(this.resolveRpcErrorMessage(fallbackError, fallbackError.message || '写入RAG失败，请稍后重试'))
          }
        } else {
          this.$message.error(message)
        }
      } finally {
        this.exporting = false
      }
    },
    async exportToRagViaBrowser(options = {}) {
      if (!await this.ensureScopeReady()) {
        throw new Error('个人知识库初始化失败')
      }
      const exportRes = await this.$http.get(`/chatApi/v1/web-scraper/tasks/${this.currentTask.taskId}/export`)
      const exportData = (exportRes.data && exportRes.data.data) || {}
      const reportName = this.currentTask.reportDocumentName || `web-report-${this.currentTask.taskId}.md`
      const reportContent = this.renderMarkdownReport(exportData)
      let ragId = this.currentTask.reportRagId
      let ragName = this.currentTask.reportRagName
      if (!ragId) {
        ragName = this.buildRagName(this.currentTask)
        ragId = await this.createTaskRag(ragName)
      }
      await this.uploadReportToRag(ragId, reportName, reportContent)
      await this.uploadDownloadedFilesToRag(ragId, exportData)
      const bindRes = await this.$http.post(`/chatApi/v1/web-scraper/tasks/${this.currentTask.taskId}/rag-binding`, {
        taskId: this.currentTask.taskId,
        ragId,
        ragName,
        documentId: `doc_${this.currentTask.taskId}`,
        documentName: reportName,
        status: 'SUCCESS',
      })
      const data = (bindRes.data && bindRes.data.data) || {}
      this.currentTask.reportRagId = data.ragId
      this.currentTask.reportRagName = data.ragName
      this.currentTask.reportStatus = data.status
      this.currentTask.reportDocumentName = data.documentName
      if (this.currentTask.taskId) {
        this.$delete(this.autoExportTaskIds, this.currentTask.taskId)
      }
      this.loadTasks()
      if (!options.silent) {
        this.$message.success(`已写入RAG：${data.ragName || data.ragId || '-'}`)
      }
    },
    buildRagName(task) {
      const time = new Date().toISOString().slice(0, 19).replace(/[T:]/g, '-')
      return `数据分析-${task.taskId}-${time}`
    },
    async createTaskRag(ragName) {
      const request = new RagKnowledgeBaseCreateRequest()
      request.setScopeId(this.currentScopeId)
      request.setName(ragName)
      request.setDescription('数据分析任务自动生成的报告知识库')
      request.setType('DOCUMENT')
      request.setParserStrategy('auto')
      request.setChunkStrategy('general')
      request.setStorageProvider('minio')
      const response = await ragServiceClient.ragKnowledgeBaseCreate(request, this.getMetadata())
      const knowledgeBase = response.getKnowledgeBase()
      if (!knowledgeBase || !knowledgeBase.getId()) {
        throw new Error('创建知识库失败：未返回知识库ID')
      }
      return knowledgeBase.getId()
    },
    async uploadReportToRag(ragId, reportName, reportContent) {
      const request = new RagKnowledgeBaseUploadRequest()
      request.setScopeId(this.currentScopeId)
      request.setKnowledgeBaseId(ragId)
      request.setName(reportName)
      request.setFile(new TextEncoder().encode(reportContent))
      const response = await ragServiceClient.ragKnowledgeBaseUpload(request, this.getMetadata())
      if (!response.getStatus()) {
        throw new Error(response.getMessage() || '上传报告到知识库失败')
      }
    },
    async uploadDownloadedFilesToRag(ragId, exportData) {
      const files = this.collectExportFiles(exportData).filter(file => file && file.status === 'SUCCESS' && (file.storageUrl || file.sourceUrl))
      for (const file of files) {
        const url = file.storageUrl || file.sourceUrl
        const response = await fetch(url, { credentials: 'omit' })
        if (!response.ok) {
          throw new Error(`附件上传RAG失败：${file.fileName || url}`)
        }
        const bytes = new Uint8Array(await response.arrayBuffer())
        const request = new RagKnowledgeBaseUploadRequest()
        request.setScopeId(this.currentScopeId)
        request.setKnowledgeBaseId(ragId)
        request.setName(file.fileName || `web-file-${Date.now()}`)
        request.setFile(bytes)
        const uploadResponse = await ragServiceClient.ragKnowledgeBaseUpload(request, this.getMetadata())
        if (!uploadResponse.getStatus()) {
          throw new Error(uploadResponse.getMessage() || `附件上传RAG失败：${file.fileName || url}`)
        }
      }
    },
    isExactExportItem(item) {
      if (!item) return false
      if (item.exactMatched === true) return true
      const source = String(item.matchSource || '').toUpperCase()
      return source === 'EXACT' || source === 'BOTH'
    },
    collectExportFiles(exportData) {
      const fileMap = {}
      const reports = Array.isArray(exportData && exportData.keywordReports) ? exportData.keywordReports : []
      reports.forEach(report => {
        const pages = Array.isArray(report.pageList) ? report.pageList : []
        pages.filter(page => this.isExactExportItem(page)).forEach(page => {
          const files = Array.isArray(page.files) ? page.files : []
          files.forEach(file => {
            const key = file.id || file.objectKey || file.storageUrl || file.sourceUrl
            if (key) fileMap[key] = file
          })
        })
      })
      return Object.values(fileMap)
    },
    renderMarkdownReport(exportData) {
      const lines = []
      lines.push('# 数据分析抓取报告', '')
      lines.push(`- 任务ID: ${exportData.taskId || (this.currentTask && this.currentTask.taskId) || ''}`)
      lines.push(`- 抓取来源: ${exportData.startUrl || (this.currentTask && this.currentTask.startUrl) || ''}`)
      lines.push(`- 成功页数: ${(this.currentTask && this.currentTask.successPages) || 0}`, '')
      const reports = (Array.isArray(exportData.keywordReports) ? exportData.keywordReports : [])
        .map(report => ({
          report,
          pages: (Array.isArray(report.pageList) ? report.pageList : []).filter(page => this.isExactExportItem(page)),
          groups: (Array.isArray(report.thematicGroups) ? report.thematicGroups : [])
            .map(group => ({
              ...group,
              items: (Array.isArray(group.items) ? group.items : []).filter(item => this.isExactExportItem(item))
            }))
            .filter(group => group.items.length)
        }))
        .filter(entry => entry.pages.length || entry.groups.length || Number(entry.report.exactCount || 0) > 0)
      if (!reports.length) {
        lines.push('暂无可写入知识库的精确命中结果。')
        return lines.join('\n')
      }
      reports.forEach(({ report, pages, groups }) => {
        lines.push(`## ${report.keyword || '关键词'}`, '')
        lines.push(`- 精确命中页面: ${pages.length || report.exactCount || 0}`)
        const exactDates = [
          ...pages.map(page => page.publishDate),
          ...groups.reduce((dates, group) => dates.concat(group.items.map(item => item.publishDate)), [])
        ].map(value => String(value || '').trim()).filter(Boolean).sort()
        if (exactDates.length) {
          lines.push(`- 时间范围: ${exactDates[0]} 至 ${exactDates[exactDates.length - 1]}`)
        }
        lines.push('')
        if (pages.length) {
          lines.push('### 来源页面', '')
          pages.forEach((page, index) => {
            const title = page.title || page.originalTitle || page.url || `页面${index + 1}`
            lines.push(`${index + 1}. [${this.escapeMarkdownText(title)}](${page.url || ''})${page.publishDate ? ` - ${page.publishDate}` : ''}`)
            lines.push('   - 匹配类型：精确命中')
            const evidences = Array.isArray(page.evidences) ? page.evidences : []
            evidences.slice(0, 3).forEach(evidence => {
              if (String(evidence || '').trim()) {
                lines.push(`   - 原文定位证据：${String(evidence).slice(0, 120)}`)
              }
            })
            const files = Array.isArray(page.files) ? page.files : []
            files.forEach(file => {
              const fileUrl = file.storageUrl || file.sourceUrl || ''
              const fileName = file.fileName || fileUrl || '附件'
              lines.push(`   - 附件：[${this.escapeMarkdownText(fileName)}](${fileUrl}) ${this.fileSizeText(file.fileSize)} ${this.fileStatusText(file.status)}`)
            })
          })
          lines.push('')
        }
        groups.forEach(group => {
          lines.push(`### ${group.theme || '主题'}`, '')
          const items = Array.isArray(group.items) ? group.items : []
          items.forEach(item => {
            lines.push(`#### ${item.title || item.url || '页面'}`)
            if (item.url) lines.push(`[来源链接](${item.url})`)
            if (item.publishDate) lines.push(`发布时间：${item.publishDate}`)
            if (item.summary) lines.push('', item.summary)
            const evidences = Array.isArray(item.evidences) ? item.evidences : []
            evidences.slice(0, 3).forEach(evidence => {
              lines.push(`> ${String(evidence || '').slice(0, 120)}`)
            })
            lines.push('')
          })
        })
      })
      return lines.join('\n')
    },
    escapeMarkdownText(value) {
      return String(value || '').replace(/[[\]]/g, '\\$&')
    },
  },
}
</script>

<style scoped>
.smart-classify-page { min-width: 1200px; min-height: 100vh; background: var(--bg-page); color: #222; }
.smart-workspace-shell { display: flex; width: 100%; min-width: 0; }

.site-tool-sidebar {
  box-sizing: border-box;
  border-right: 1px solid var(--border);
  background: linear-gradient(180deg, var(--bg-card) 0%, var(--primary-alpha-05) 100%);
}

.site-tool-section + .site-tool-section {
  position: relative;
  margin-top: 8px;
  padding-top: 7px;
}

.site-tool-section + .site-tool-section::before {
  position: absolute;
  top: 0;
  right: 8px;
  left: 8px;
  height: 1px;
  background: var(--border);
  content: "";
}

.site-tool-section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 12px 8px 8px;
  color: var(--primary-dark);
  font-size: 15px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: .04em;
}

.site-tool-section-title::before {
  flex: 0 0 3px;
  width: 3px;
  height: 14px;
  border-radius: 999px;
  background: var(--primary-gradient);
  box-shadow: 0 2px 6px rgba(0, 0, 0, .22);
  content: "";
}

.site-tool-item {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-width: 0;
  min-height: 42px;
  margin: 0 0 4px;
  padding: 0 8px;
  overflow: hidden;
  box-sizing: border-box;
  color: var(--muted-foreground);
  border: 1px solid transparent;
  border-radius: 9px;
  background: transparent;
  cursor: pointer;
  font-family: inherit;
  text-align: left;
  transition: color .16s ease, border-color .16s ease, background-color .16s ease, box-shadow .16s ease;
}

.site-tool-icon {
  flex: 0 0 18px;
  width: 18px;
  color: var(--muted-foreground);
  font-size: 16px;
  text-align: center;
  transition: color .16s ease;
}

.site-tool-name {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  font-size: 14px;
  font-weight: 500;
  line-height: 40px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.site-tool-item:not(.active):hover,
.site-tool-item:not(.active):focus-visible {
  color: var(--primary-dark);
  border-color: var(--border);
  background: var(--primary-alpha-08);
  box-shadow: 0 4px 12px rgba(0, 0, 0, .08);
}

.site-tool-item:not(.active):hover .site-tool-icon,
.site-tool-item:not(.active):focus-visible .site-tool-icon {
  color: var(--primary);
}

.site-tool-item:focus-visible {
  outline: 2px solid rgba(16, 185, 129, .3);
  outline-offset: 1px;
}

.site-tool-item.active {
  color: #ffffff;
  border-color: transparent;
  background: var(--primary-gradient);
  box-shadow: 0 6px 16px rgba(0, 0, 0, .2);
}

.site-tool-item.active .site-tool-icon,
.site-tool-item.active .site-tool-name {
  color: #ffffff;
  font-weight: 600;
}

.smart-layout { width: calc(100% - 96px); min-width: 1100px; max-width: 1400px; margin: 28px auto; display: flex; gap: 20px; align-items: flex-start; box-sizing: border-box; }
.smart-panel { background: #fff; border: 1px solid var(--border); border-radius: 6px; padding: 22px; box-sizing: border-box; }
.side-panel { width: 340px; flex-shrink: 0; }
.smart-main { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 20px; }

.panel-title { font-size: 18px; font-weight: 700; margin-bottom: 16px; }
.target-head { display: flex; align-items: flex-start; justify-content: space-between; gap: 12px; margin-bottom: 14px; }
.target-head .panel-title { margin-bottom: 6px; }
.target-subtitle { color: var(--muted-foreground); font-size: 12px; line-height: 18px; }
.add-target-btn { background: var(--primary); border-color: var(--primary); box-shadow: 0 5px 14px rgba(0, 0, 0,.18); }
.add-target-btn:hover, .add-target-btn:focus { background: var(--primary-dark); border-color: var(--primary-dark); }
.target-list {
  max-height: 470px; overflow: auto; padding-right: 2px; scrollbar-width: thin; scrollbar-color: #c5d2dc transparent;
}
.target-list::-webkit-scrollbar { width: 4px; }
.target-list::-webkit-scrollbar-thumb { background: #c5d2dc; border-radius: 4px; }
.target-list::-webkit-scrollbar-track { background: transparent; }
.target-card {
  padding: 12px; margin-bottom: 12px; border: 1px solid var(--border); border-radius: 6px; background: #fff;
  cursor: pointer; transition: border-color .2s, box-shadow .2s, background .2s;
}
.target-card.active { border-color: var(--primary); background: var(--primary-alpha-08); box-shadow: 0 3px 12px rgba(0, 0, 0, .08); }
.target-card-head { display: flex; align-items: center; gap: 8px; margin-bottom: 10px; }
.target-index {
  width: 22px; height: 22px; border-radius: 50%; background: var(--primary-alpha-08); color: var(--primary);
  display: inline-flex; align-items: center; justify-content: center; font-size: 12px; font-weight: 700;
}
.target-card-title { color: #4f5965; font-size: 13px; font-weight: 600; }
.target-card-actions { margin-left: auto; display: flex; align-items: center; gap: 4px; }
.target-card-actions /deep/ .el-button { padding: 0; color: var(--muted-foreground); font-size: 15px; }
.target-card-actions /deep/ .el-button:hover { color: var(--primary); }
.target-progress { display: grid; grid-template-columns: 64px 1fr 36px; align-items: center; gap: 8px; margin: 10px 0; color: var(--muted-foreground); font-size: 12px; }
.target-progress em { color: #4f5965; font-style: normal; text-align: right; }
.target-progress /deep/ .el-progress-bar__inner { background-color: var(--primary); }
.target-keyword-head { display: flex; justify-content: space-between; color: #4f5965; font-size: 12px; line-height: 20px; }
.target-keyword-input { display: grid; grid-template-columns: 1fr 40px; gap: 8px; align-items: center; margin-top: 6px; }
.target-keyword-input /deep/ .el-button--text { color: var(--primary); }
.target-tags { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 8px; }
.target-tags /deep/ .el-tag { background: var(--primary-alpha-08); border-color: var(--border); color: var(--primary); }
.target-empty { margin-top: 8px; color: #b0bac5; font-size: 12px; line-height: 18px; }
.batch-form { margin-top: 18px; padding-top: 18px; border-top: 1px solid #edf1f5; }
.schedule-box { padding: 12px; margin-bottom: 14px; background: #f8fbfd; border: 1px solid #e6edf5; border-radius: 6px; }
.schedule-title { margin-bottom: 10px; color: #222; font-size: 14px; font-weight: 700; }
.schedule-segment { display: grid; grid-template-columns: repeat(3, 1fr); border: 1px solid #d9e2ea; border-radius: 4px; overflow: hidden; background: #fff; }
.schedule-segment button {
  height: 30px; border: 0; border-right: 1px solid #d9e2ea; background: #fff; color: #4f5965; font-size: 12px; cursor: pointer;
}
.schedule-segment button:last-child { border-right: 0; }
.schedule-segment button.active { background: var(--primary); color: #fff; font-weight: 700; }
.result-title-row { display: flex; align-items: center; gap: 12px; }
.result-title-row .panel-title { margin-bottom: 0; }
.result-head { display: flex; align-items: flex-start; justify-content: space-between; margin-bottom: 16px; }
.result-actions { display: flex; align-items: center; gap: 8px; flex-shrink: 0; }

.workbench-panel { min-height: 700px; }
.workbench-head { display: flex; align-items: flex-start; justify-content: space-between; gap: 20px; margin-bottom: 16px; }
.workbench-head .panel-title { margin-bottom: 6px; }
.workbench-subtitle { color: var(--muted-foreground); font-size: 13px; line-height: 20px; }
.workspace-tabs /deep/ .el-tabs__header { margin: 0 0 18px; }
.workspace-tabs /deep/ .el-tabs__item.is-active { color: var(--primary); }
.workspace-tabs /deep/ .el-tabs__active-bar { background-color: var(--primary); }
.process-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
.process-card { min-height: 150px; padding: 16px; border: 1px solid var(--border); border-radius: 6px; background: #fff; }
.process-card-title { color: #222; font-size: 15px; font-weight: 700; line-height: 22px; }
.task-actions { display: flex; align-items: center; gap: 8px; }
.cancel-task-btn { color: #d93025 !important; }
.task-live-progress {
  display: flex; align-items: flex-start; justify-content: space-between; gap: 12px;
  margin-top: 12px; padding: 10px 12px; border: 1px solid var(--border); border-radius: 5px; background: #f5fbfe;
}
.task-live-progress > div { min-width: 0; display: flex; flex-direction: column; gap: 3px; }
.task-live-progress span { color: var(--primary); font-size: 12px; font-weight: 700; }
.task-live-progress strong { color: #4f5965; font-size: 13px; font-weight: 500; line-height: 19px; word-break: break-word; }
.current-page-link { flex-shrink: 0; border: 0; background: transparent; color: var(--primary); cursor: pointer; font-size: 12px; }
.selected-task-actions { display: flex; align-items: center; gap: 8px; margin-top: 12px; }
.target-progress-list { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 12px; }
.target-pill {
  display: inline-flex; align-items: center; gap: 7px; min-width: 112px; height: 34px; padding: 0 10px;
  border: 1px solid var(--border); border-radius: 4px; background: #fff; color: #4f5965; cursor: pointer;
}
.target-pill.active { border-color: var(--primary); background: var(--primary-alpha-08); color: var(--primary); }
.target-pill span {
  width: 18px; height: 18px; border-radius: 50%; background: #edf3f7; display: inline-flex; align-items: center; justify-content: center; font-size: 12px;
}
.target-pill em { font-style: normal; font-size: 12px; }
.target-pill strong { margin-left: auto; font-size: 12px; }
.process-log { margin-top: 16px; padding: 16px; border: 1px solid var(--border); border-radius: 6px; background: #fff; }
.process-log-head { display: flex; align-items: center; justify-content: space-between; color: #222; font-size: 15px; font-weight: 700; }
.process-log-head .el-button--text { color: var(--primary); }
.process-log-list { max-height: 330px; overflow: auto; margin-top: 10px; border-top: 1px solid #edf1f5; }
.process-log-item { display: grid; grid-template-columns: 72px 1fr; gap: 10px; padding: 9px 0; border-bottom: 1px solid #f0f3f7; color: #4f5965; font-size: 13px; }
.process-log-item span { color: #9aa3ad; }
.process-log-item p { margin: 0; word-break: break-word; }
.process-log-item.success p { color: #1a7f37; }
.process-log-item.error p { color: #d93025; }
.process-log-item.warning p { color: #b7791f; }
.data-center-head { display: flex; align-items: flex-start; justify-content: space-between; gap: 16px; margin-bottom: 14px; }
.data-center-subtitle {
  max-width: 520px; margin-top: 4px; color: var(--muted-foreground); font-size: 13px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.data-current-summary {
  display: grid; grid-template-columns: repeat(auto-fit, minmax(130px, 1fr)); gap: 10px; margin-bottom: 14px;
}
.data-current-summary div {
  min-width: 0; padding: 10px 12px; border: 1px solid #e3edf4; border-radius: 6px; background: #f8fbfd;
}
.data-current-summary span { display: block; margin-bottom: 4px; color: var(--muted-foreground); font-size: 12px; }
.data-current-summary strong {
  display: block; color: #263340; font-size: 14px; font-weight: 700; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.data-table /deep/ th { color: var(--muted-foreground); font-weight: 700; background: #fff; }

.form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.model-select { width: 100%; }
.keyword-help, .compliance-help { margin-top: 6px; color: #9aa3ad; font-size: 12px; line-height: 18px; }
.compliance-help { margin-top: 8px; }
.compliance-item /deep/ .el-form-item__content { line-height: 18px; }
.compliance-item /deep/ .el-checkbox { display: flex; align-items: flex-start; white-space: normal; }
.compliance-item /deep/ .el-checkbox__input { flex: 0 0 auto; margin-top: 2px; }
.compliance-item /deep/ .el-checkbox__label { flex: 1; min-width: 0; white-space: normal; word-break: break-word; color: #4f5965; font-size: 12px; line-height: 18px; padding-left: 8px; }
.submit-btn { width: 100%; background: var(--primary); border-color: var(--primary); box-shadow: 0 5px 14px rgba(0, 0, 0,.18); }
.submit-btn:hover, .submit-btn:focus { background: var(--primary-dark); border-color: var(--primary-dark); }

.history-head { display: flex; align-items: center; justify-content: space-between; margin: 28px 0 12px; font-weight: 700; }
.history-head .el-button--text { color: var(--primary); }
.history-list {
  max-height: 420px; overflow: auto; scrollbar-width: thin; scrollbar-color: #c5d2dc transparent;
}
.history-list::-webkit-scrollbar { width: 4px; }
.history-list::-webkit-scrollbar-thumb { background: #c5d2dc; border-radius: 4px; }
.history-list::-webkit-scrollbar-track { background: transparent; }
.history-item {
  padding: 12px; border: 1px solid var(--border); border-radius: 6px; margin-bottom: 10px; cursor: pointer; background: var(--primary-alpha-08);
  transition: border-color .2s, box-shadow .2s, background .2s;
}
.history-item:hover,
.history-item.active { border-color: var(--primary); box-shadow: 0 3px 12px rgba(0, 0, 0, .08); }
.history-card-head { display: flex; align-items: center; gap: 8px; min-width: 0; margin-bottom: 10px; }
.history-card-head .target-index { flex: 0 0 auto; }
.history-url {
  min-width: 0; color: #666; font-size: 13px; line-height: 20px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.history-keywords { display: flex; align-items: center; gap: 6px; min-width: 0; margin: 2px 0 8px; overflow: hidden; }
.history-keyword-label { flex: 0 0 auto; color: var(--muted-foreground); font-size: 12px; line-height: 20px; }
.history-keywords /deep/ .el-tag {
  max-width: 72px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
  background: var(--primary-alpha-08); border-color: var(--border); color: var(--primary);
}
.task-url { color: #666; font-size: 13px; word-break: break-all; }
.history-meta { margin-top: 6px; color: #999; font-size: 12px; }

.task-model { margin-top: 6px; color: #888; font-size: 13px; }
.task-actions { display: flex; align-items: center; gap: 8px; flex-shrink: 0; }
.retry-task-btn { padding: 0; color: var(--primary); font-size: 18px; }
.retry-task-btn:hover, .retry-task-btn:focus { color: var(--primary-dark); }
.task-error { margin-top: 16px; }

.stat-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; margin-top: 18px; }
.stat-grid div { background: #f7f9fc; border-radius: 6px; padding: 14px; }
.stat-grid span { display: block; font-size: 24px; font-weight: 700; color: var(--primary-dark); }
.stat-grid label { color: #777; font-size: 13px; }

.result-panel { min-height: 560px; }
.success-summary { margin-bottom: 16px; color: var(--foreground); font-size: 15px; font-weight: 700; }
.matched-pages-summary {
  margin-bottom: 16px; padding: 14px; border: 1px solid var(--border); border-radius: 6px; background: #fbfdff;
}
.matched-pages-head { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.matched-pages-head strong { color: #263340; font-size: 14px; }
.matched-pages-head span { color: var(--muted-foreground); font-size: 12px; }
.matched-pages-list { display: flex; flex-direction: column; gap: 8px; max-height: 280px; margin-top: 12px; overflow-y: auto; }
.matched-page-item { padding: 10px 12px; border: 1px solid #e5edf3; border-radius: 4px; background: #fff; }
.matched-page-main { display: flex; align-items: center; gap: 8px; min-width: 0; }
.matched-page-main .title-link { flex: 1; min-width: 0; color: var(--foreground); }
.matched-page-meta { display: flex; align-items: center; gap: 14px; min-width: 0; margin-top: 6px; color: var(--muted-foreground); font-size: 12px; }
.matched-page-meta span { min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.matched-page-meta span:last-child { flex: 1; }
.matched-pages-empty { margin-top: 12px; color: var(--muted-foreground); font-size: 13px; }
.page-match-tags { display: flex; flex-wrap: wrap; gap: 4px; }
.page-keyword-lines { display: flex; flex-direction: column; gap: 4px; color: #4f5965; font-size: 12px; line-height: 18px; }
.page-keyword-lines span { min-width: 0; overflow-wrap: anywhere; }
.page-keyword-lines em {
  display: inline-block; min-width: 30px; margin-right: 6px; border-radius: 3px; padding: 0 4px;
  font-style: normal; font-size: 10px; line-height: 17px; text-align: center;
}
.page-keyword-lines em.exact { background: #e8f6ed; color: #1a7f37; }
.page-keyword-lines em.semantic { background: #fff5e6; color: #b7791f; }
.page-keyword-lines em.legacy { background: #f0f2f5; color: #727b86; }
.result-tabs { width: 100%; }
.result-tabs /deep/ .el-tabs__header { margin-bottom: 0; border-bottom: 1px solid #dcdfe6; }
.result-tabs /deep/ .el-tabs__nav-wrap { max-width: 100%; overflow: hidden; }
.result-tabs /deep/ .el-tabs__nav-scroll {
  width: 100%; overflow-x: auto; overflow-y: hidden;
}
.result-tabs /deep/ .el-tabs__nav-scroll::-webkit-scrollbar { height: 6px; }
.result-tabs /deep/ .el-tabs__nav-scroll::-webkit-scrollbar-thumb { background: #d5dee8; border-radius: 6px; }
.result-tabs /deep/ .el-tabs__nav-scroll::-webkit-scrollbar-track { background: transparent; }
.result-tabs /deep/ .el-tabs__nav { border-radius: 4px 4px 0 0; white-space: nowrap; }
.result-tabs /deep/ .el-tabs__item {
  min-width: 118px; max-width: 180px; padding: 0 18px; text-align: center;
  overflow: hidden; background: #fff; user-select: none;
}
.result-tabs /deep/ .el-tabs__item:hover,
.result-tabs /deep/ .el-tabs__item:focus,
.result-tabs /deep/ .el-tabs__item.is-active {
  color: var(--primary); background: #fff;
}
.result-tabs /deep/ .el-tabs__content {
  min-height: 360px; padding-top: 14px; border-top: 1px solid var(--border);
}
.tab-label { display: flex; align-items: center; gap: 6px; width: 100%; max-width: 154px; overflow: hidden; }
.page-match-mark {
  flex: 0 0 auto; padding: 0 4px; border-radius: 3px; background: #e8f6ed; color: #1a7f37; font-size: 10px; line-height: 18px;
}
.page-match-mark.semantic { background: #fff5e6; color: #b7791f; }
.page-match-mark.both { background: #e9efff; color: var(--primary-dark); }
.page-match-mark.legacy { background: #f0f2f5; color: #727b86; }
.page-match-mark.miss { background: #f0f2f5; color: var(--muted-foreground); }
.tab-label-text { display: block; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.tab-download-btn {
  flex: 0 0 auto; width: 20px; height: 20px; border: 0; border-radius: 4px; padding: 0; background: transparent;
  color: var(--muted-foreground); cursor: pointer; line-height: 20px;
}
.tab-download-btn:hover, .tab-download-btn:focus { color: var(--primary); background: var(--primary-alpha-08); }
.result-table /deep/ th { color: var(--muted-foreground); font-weight: 700; background: #fff; }
.result-table /deep/ td, .result-table /deep/ th.is-leaf { border-bottom-color: var(--border); }
.result-table /deep/ .el-table__body tr:hover > td,
.data-table /deep/ .el-table__body tr:hover > td,
.report-table /deep/ .el-table__body tr:hover > td { background: var(--primary-alpha-05) !important; }
.page-report { padding: 8px 2px 4px; color: #263340; }
.page-report-title-row {
  display: flex; align-items: center; flex-wrap: wrap; gap: 12px; margin: 0 0 18px;
}
.page-report-title {
  margin: 0; color: #222; font-size: 20px; font-weight: 700; line-height: 30px;
}
.page-report-download-btn { flex: 0 0 auto; }
.report-section { margin-top: 22px; }
.report-section h3 {
  margin: 0 0 12px; color: #222; font-size: 16px; font-weight: 700; line-height: 24px;
}
.report-section h4 {
  margin: 16px 0 8px; color: var(--primary-dark); font-size: 15px; font-weight: 700; line-height: 24px;
}
.report-overview {
  display: grid; gap: 8px; padding: 14px 16px; background: #f8fbfd; border: 1px solid #e6edf5; border-radius: 4px;
  color: #4f5965; font-size: 14px; line-height: 22px;
}
.report-overview span { color: #222; font-weight: 700; }
.report-table { width: 100%; }
.report-table /deep/ th { color: var(--muted-foreground); font-weight: 700; background: #fff; }
.file-list { display: flex; flex-direction: column; gap: 8px; }
.file-item {
  padding: 10px 12px; border: 1px solid #e2edf4; border-radius: 4px; background: #f8fbfd;
}
.file-main { display: flex; align-items: center; gap: 8px; min-width: 0; }
.file-main i { color: var(--foreground); font-size: 16px; }
.file-name {
  min-width: 0; max-width: 520px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; text-align: left;
}
.file-meta {
  display: flex; align-items: center; gap: 12px; min-width: 0; margin-top: 6px; color: var(--muted-foreground); font-size: 12px;
}
.file-meta span {
  max-width: 420px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.summary-groups { display: flex; flex-direction: column; gap: 8px; }
.summary-group { padding-bottom: 4px; }
.summary-item { margin-bottom: 12px; color: #4f5965; font-size: 14px; line-height: 24px; }
.summary-item-title { margin: 0 0 8px; }
.evidence-list { margin: 0; padding-left: 20px; color: #606975; }
.evidence-list li { margin-bottom: 4px; line-height: 22px; }
.empty-report-block {
  padding: 14px 16px; color: #9aa3ad; background: #f8fbfd; border: 1px dashed #d8e2ec; border-radius: 4px;
}
.graph-tabs { margin-top: 4px; }
.graph-tabs .el-tabs__content { padding-top: 6px; overflow: visible; }
.graph-canvas-wrap {
  width: 100%; overflow-x: auto; margin-bottom: 12px;
  background: #fcfdff; border: 1px solid #eef3f8; border-radius: 6px; padding: 8px;
}
.graph-canvas { display: block; width: 100%; height: auto; min-width: 560px; }
.graph-svg-edge { stroke: #d4dde6; stroke-width: 1; }
.graph-svg-circle { stroke: #fff; stroke-width: 1.5; }
.graph-svg-circle.is-center { stroke-width: 2.5; }
.graph-svg-label { font-size: 12px; fill: #303a45; dominant-baseline: middle; }
.graph-svg-label.is-center { font-size: 14px; font-weight: 700; fill: #c0392b; }
.graph-svg-label-en { font-size: 10px; fill: var(--muted-foreground); dominant-baseline: middle; }
.graph-legend { display: flex; flex-wrap: wrap; gap: 14px; margin: 4px 0 14px; font-size: 12px; color: #5a6571; }
.graph-legend-item { display: inline-flex; align-items: center; gap: 6px; }
.graph-legend-dot { width: 10px; height: 10px; border-radius: 50%; display: inline-block; }
.graph-list { display: flex; flex-direction: column; gap: 10px; }
.graph-relation { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; color: #4f5965; font-size: 13px; }
.graph-node {
  max-width: 280px; padding: 6px 10px; border: 1px solid var(--border); border-radius: 4px; background: #f5fbff;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.graph-edge { color: var(--primary); font-weight: 700; }
.page-detail-url { display: flex; align-items: center; gap: 6px; margin-top: 18px; color: var(--muted-foreground); }
.page-detail-url .safe-url-link { max-width: 760px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; text-align: left; }
.rag-result {
  display: flex; align-items: center; gap: 18px; flex-wrap: wrap;
  margin-bottom: 16px; padding: 12px 14px; background: #f4f9fc; border: 1px solid var(--border); border-radius: 6px;
}
.rag-result div { display: flex; align-items: center; gap: 6px; min-width: 0; }
.rag-result span { color: var(--muted-foreground); font-size: 12px; }
.rag-result strong {
  color: #263340; font-size: 13px; font-weight: 600; max-width: 260px;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.rag-result .el-button--text { color: var(--primary); padding: 0; }

.running-placeholder {
  display: flex; align-items: center; justify-content: center; gap: 10px;
  padding: 60px 0; color: #888; font-size: 15px;
}
.running-placeholder.has-pages { justify-content: flex-start; margin-bottom: 14px; padding: 12px 14px; border-radius: 5px; background: #f5fbfe; }
.running-placeholder span { line-height: 22px; }
.running-placeholder em { display: block; color: var(--primary); font-size: 12px; font-style: normal; }
.running-icon { font-size: 22px; color: var(--primary); }

.safe-url-link { border: 0; padding: 0; background: transparent; color: var(--foreground); font-size: 13px; line-height: 20px; cursor: pointer; }
.safe-url-link:hover { color: var(--primary-dark); text-decoration: underline; }
.result-table .safe-url-link { color: var(--foreground); }
.title-link { max-width: 100%; overflow: hidden; text-align: left; text-overflow: ellipsis; white-space: nowrap; display: block; }
.muted { color: #aaa; }

.kw-no-match { padding: 20px; color: #aaa; font-size: 14px; }

.kw-section { padding: 20px 20px 0; }
.kw-section:last-child { padding-bottom: 20px; }
.kw-section-title { font-size: 15px; font-weight: 700; color: #222; margin-bottom: 12px; padding-bottom: 6px; border-bottom: 2px solid var(--primary); display: inline-block; }

.overview-grid { display: flex; flex-direction: column; gap: 8px; background: #f8fafd; border-radius: 6px; padding: 14px 18px; }
.overview-row { display: flex; align-items: baseline; gap: 12px; font-size: 14px; }
.ov-label { color: #888; width: 70px; flex-shrink: 0; font-size: 13px; }

.content-table { width: 100%; }
.original-title-cell { color: #555; font-size: 12px; font-style: italic; }

.thematic-group { margin-bottom: 18px; }
.thematic-group-title { font-size: 14px; font-weight: 700; color: var(--primary-dark); margin-bottom: 10px; }

.thematic-item { padding: 12px; border: 1px solid var(--border); border-radius: 6px; background: #f9fbfd; margin-bottom: 10px; }
.thematic-item-head { display: flex; align-items: center; gap: 10px; margin-bottom: 6px; }
.thematic-item-title { border: 0; padding: 0; background: transparent; color: var(--primary); font-size: 14px; font-weight: 600; cursor: pointer; text-align: left; }
.thematic-item-title:hover { text-decoration: underline; }
.thematic-item-date { color: #999; font-size: 12px; flex-shrink: 0; }
.thematic-item-summary { margin: 0 0 8px; color: #303133; font-size: 13px; line-height: 20px; }

.evidence-list { display: flex; flex-direction: column; gap: 4px; }
.evidence-item { padding: 6px 10px; border-left: 3px solid var(--primary); background: #fff; color: #606975; font-size: 12px; line-height: 18px; }

.safe-url-link { border: 0; padding: 0; background: transparent; color: var(--foreground); font-size: 13px; line-height: 20px; cursor: pointer; }
.safe-url-link:hover, .safe-url-link:focus { color: var(--primary-dark); text-decoration: underline; }
.title-link { max-width: 100%; overflow: hidden; text-align: left; text-overflow: ellipsis; white-space: nowrap; }

.muted { color: #aaa; }


.smart-mobile-view-switch { display: none; }

@media (max-width: 768px) {
  .smart-classify-page {
    width: 100%;
    min-width: 0;
    min-height: 100vh;
    min-height: 100dvh;
    overflow-x: hidden;
  }

  .smart-workspace-shell {
    display: block;
  }

  .smart-workspace-shell > .site-tool-sidebar {
    display: none;
  }

  .smart-mobile-view-switch {
    position: sticky;
    z-index: 20;
    top: 56px;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 4px;
    width: 100%;
    padding: 8px 12px;
    border-bottom: 1px solid #e3eaf1;
    background: rgba(255, 255, 255, .96);
    box-shadow: 0 4px 12px rgba(34, 66, 94, .06);
    box-sizing: border-box;
  }

  .smart-mobile-view-switch button {
    min-width: 0;
    min-height: 42px;
    padding: 0 12px;
    border: 0;
    border-radius: 6px;
    background: #f2f5f8;
    color: #5c6875;
    font-size: 14px;
    font-weight: 600;
  }

  .smart-mobile-view-switch button.active {
    background: var(--primary);
    color: #fff;
    box-shadow: 0 3px 10px rgba(0, 0, 0, .2);
  }

  .smart-layout {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    min-width: 0;
    max-width: none;
    margin: 0;
    padding: 12px;
    gap: 12px;
    overflow: visible;
    box-sizing: border-box;
  }

  .smart-layout.mobile-pane-settings > .smart-main,
  .smart-layout.mobile-pane-analysis > .side-panel {
    display: none;
  }

  .smart-layout > .side-panel,
  .smart-layout > .smart-main,
  .smart-panel {
    width: 100%;
    min-width: 0;
    max-width: 100%;
    height: auto;
    box-sizing: border-box;
  }

  .smart-layout > .side-panel,
  .smart-layout > .smart-main {
    flex: 0 0 auto;
    overflow: visible;
  }

  .smart-panel {
    padding: 16px;
    border-radius: 8px;
  }

  .smart-main { gap: 12px; }
  .workbench-panel,
  .result-panel,
  .process-card,
  .workspace-tabs /deep/ .el-tabs__content,
  .result-tabs /deep/ .el-tabs__content {
    min-height: 0;
  }

  .panel-title {
    margin-bottom: 12px;
    font-size: 17px;
    line-height: 24px;
  }

  .target-head,
  .workbench-head,
  .result-head,
  .data-center-head {
    flex-wrap: wrap;
    gap: 10px;
  }

  .target-head > div,
  .workbench-head > div,
  .result-head > div:first-child,
  .data-center-head > div:first-child {
    min-width: 0;
  }

  .add-target-btn,
  .submit-btn,
  .result-actions /deep/ .el-button,
  .data-center-head /deep/ .el-button {
    min-height: 40px;
  }

  .target-list,
  .history-list,
  .process-log-list {
    max-height: none;
    padding-right: 0;
    overflow: visible;
  }

  .target-card,
  .history-item,
  .process-card,
  .process-log {
    min-width: 0;
  }

  .target-list /deep/ .el-empty,
  .history-list /deep/ .el-empty,
  .process-log /deep/ .el-empty {
    padding: 22px 0;
  }

  .schedule-segment button {
    min-width: 0;
    height: 42px;
    padding: 0 4px;
  }

  .smart-layout /deep/ .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  .process-grid {
    grid-template-columns: minmax(0, 1fr);
    gap: 12px;
  }

  .target-pill {
    min-height: 42px;
    height: auto;
    padding-top: 6px;
    padding-bottom: 6px;
  }

  .workspace-tabs /deep/ .el-tabs__nav-wrap,
  .workspace-tabs /deep/ .el-tabs__nav-scroll {
    max-width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
  }

  .workspace-tabs /deep/ .el-tabs__nav {
    white-space: nowrap;
  }

  .workspace-tabs /deep/ .el-tabs__item {
    height: 44px;
    padding: 0 16px;
    line-height: 44px;
  }

  .result-actions {
    display: flex;
    flex: 1 1 100%;
    flex-wrap: wrap;
    width: 100%;
    min-width: 0;
  }

  .data-center-subtitle {
    max-width: 100%;
    white-space: normal;
    overflow-wrap: anywhere;
  }

  .data-current-summary {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .stat-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 8px;
  }

  .stat-grid div {
    min-width: 0;
    padding: 10px 6px;
    text-align: center;
  }

  .stat-grid span { font-size: 20px; }

  .history-keywords,
  .file-main,
  .file-meta,
  .rag-result,
  .rag-result div,
  .page-detail-url {
    flex-wrap: wrap;
  }

  .history-keywords { overflow: visible; }

  .file-name,
  .file-meta span,
  .rag-result strong,
  .page-detail-url .safe-url-link {
    min-width: 0;
    max-width: 100%;
  }

  .result-table,
  .report-table,
  .data-table,
  .graph-canvas-wrap {
    max-width: 100%;
    box-sizing: border-box;
  }

  .result-table /deep/ .el-table__body-wrapper,
  .report-table /deep/ .el-table__body-wrapper,
  .data-table /deep/ .el-table__body-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

@media (max-width: 480px) {
  .smart-layout { padding: 8px; }
  .smart-panel { padding: 12px; }

  .form-row,
  .data-current-summary {
    grid-template-columns: minmax(0, 1fr);
  }

  .process-log-item {
    grid-template-columns: minmax(0, 1fr);
    gap: 4px;
  }

  .result-actions /deep/ .el-button {
    flex: 1 1 120px;
    margin-left: 0;
  }

  .page-report-title {
    font-size: 18px;
    line-height: 27px;
  }

  .report-section h3 {
    font-size: 15px;
    line-height: 23px;
  }
}

@media (min-width: 768.01px) {
  .smart-classify-page {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100vh;
    height: 100dvh;
    min-width: 0;
    min-height: 640px;
    overflow: hidden;
  }

  .smart-workspace-shell {
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
  }

  .smart-workspace-shell > .site-tool-sidebar {
    flex: 0 0 200px;
    width: 200px;
    height: 100%;
    min-height: 0;
    padding: 14px 14px 24px;
    overflow-x: hidden;
    overflow-y: auto;
    scrollbar-color: rgba(16, 185, 129, .28) transparent;
    scrollbar-width: thin;
  }

  .smart-workspace-shell > .site-tool-sidebar::-webkit-scrollbar {
    width: 5px;
  }

  .smart-workspace-shell > .site-tool-sidebar::-webkit-scrollbar-track {
    background: transparent;
  }

  .smart-workspace-shell > .site-tool-sidebar::-webkit-scrollbar-thumb {
    border-radius: 999px;
    background: rgba(16, 185, 129, .28);
  }

  .smart-layout {
    display: flex;
    flex: 1 1 auto;
    align-items: stretch;
    width: 100%;
    max-width: none;
    min-width: 0;
    min-height: 0;
    margin: 0;
    padding: 16px;
    overflow: hidden;
    box-sizing: border-box;
  }

  .smart-layout > .side-panel {
    flex: 0 0 340px;
    width: 340px;
    height: 100%;
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .smart-layout > .smart-main {
    flex: 1 1 auto;
    height: 100%;
    min-width: 0;
    min-height: 0;
    padding-right: 2px;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .smart-layout .workbench-panel,
  .smart-layout .result-panel {
    min-height: 100%;
  }

  .smart-classify-page .smart-site-footer {
    display: block;
    flex: 0 0 64px;
    min-height: 64px;
  }
}
</style>
